export const VisitType={
	IN_PERSON:"In-person",
	VIRTUAL_VISIT:"Virtual visit",
}

export const BackendDateFormat = 'YYYY-MM-DD HH:mm:ss Z'
export const CallendarDateFormat="'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ'"

export const ErrorMessages={
    AppTypeMultiple:"At least one reason must be selected",
    AppTypeSingle:"Reason must be selected",
    faildToCreateAPT:"Their is an error while booking an appointment.",
    faildToGetAPT:"Their is an error while fetching appointments.",
    locationSingle:"Location must be selected",
    noSchedules:"No schedules available on this location."
}

export const termsAcceptedLabel = "*By submitting your information, you consent to receiving texts and emails regarding your appointment and other general communication from our business. Data and message rates may apply"
export const steps = ['Select Appointment Details', 'Select Available Appointments', 'Your Information'];
export const customRoutes={APTDetails:"APTDetails",DRDetails:"DRDetails",appointmentForm:"appointmentForm",successAPT:"successAPT"}
export const ContactMessage="Please contact our office if your desired day and time for a same-day or future-date appointment are not available."

export const BookingData ={
    "AppointmentTypes": [
        {
            "id": 126,
            "name": "Botox",
            "short_name": "Botox",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:51:27 +0500",
            "updated_at": "2024-07-10 20:51:27 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 127,
            "name": "Botox/Filter",
            "short_name": "Botox/Filter",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:51:50 +0500",
            "updated_at": "2024-07-10 20:51:50 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 128,
            "name": "Chamical Peel",
            "short_name": "Chamical Peel",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:55:11 +0500",
            "updated_at": "2024-07-10 20:55:11 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 129,
            "name": "Consult",
            "short_name": "Consult",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:55:37 +0500",
            "updated_at": "2024-07-10 20:55:37 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 130,
            "name": "Coolsculpting",
            "short_name": "Coolsculpting",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:56:23 +0500",
            "updated_at": "2024-07-10 20:56:23 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 131,
            "name": "Cosmetic",
            "short_name": "Cosmetic",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:56:43 +0500",
            "updated_at": "2024-07-10 20:56:43 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 132,
            "name": "Eczema",
            "short_name": "Eczema",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:57:01 +0500",
            "updated_at": "2024-07-10 20:57:01 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 133,
            "name": "Filler",
            "short_name": "Filler",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:57:26 +0500",
            "updated_at": "2024-07-10 20:57:26 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 134,
            "name": "Full Skin Exam",
            "short_name": "Full Skin Exam",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:57:45 +0500",
            "updated_at": "2024-07-10 20:57:45 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 135,
            "name": "Hair Loss",
            "short_name": "Hair Loss",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:58:02 +0500",
            "updated_at": "2024-07-10 20:58:02 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 125,
            "name": "Acne",
            "short_name": "acne",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-07-10 20:50:41 +0500",
            "updated_at": "2024-07-10 20:50:41 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 80,
            "name": "Type one",
            "short_name": "id_80",
            "duration": 30,
            "user_id": 46,
            "created_at": "2023-09-29 22:31:26 +0500",
            "updated_at": "2024-08-09 02:28:43 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 112,
            "name": "Type Two",
            "short_name": "id_112",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-01-03 04:06:27 +0500",
            "updated_at": "2024-08-09 02:28:52 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        },
        {
            "id": 113,
            "name": "Type Three",
            "short_name": "id_113",
            "duration": 30,
            "user_id": 46,
            "created_at": "2024-01-03 20:01:44 +0500",
            "updated_at": "2024-08-09 02:28:58 +0500",
            "deleted_at": null,
            "with_flow": false,
            "participants": 1
        }
    ],
    "Addresses": [
        {
            "id": 70,
            "city": "STE LAKE ELSINORE",
            "state": "California",
            "county": null,
            "primary_contact": "(951)471-1912",
            "address_line_two": "",
            "address_line_one": "CENTRAL AVE",
            "zip_code": "29273",
            "created_at": "2024-01-03 20:12:21 +0500",
            "updated_at": "2024-01-03 20:13:09 +0500",
            "name": "CENTRAL AVE, LOS ANGELES",
            "deleted_at": null,
            "user_id": 46,
            "with_flow": false,
            "google_map_link": "https://maps.app.goo.gl/LQemyhBSm6Wnr1Go8"
        },
        {
            "id": 66,
            "city": "los angeles",
            "state": "California",
            "county": null,
            "primary_contact": "(123)123-1233",
            "address_line_two": "",
            "address_line_one": "San Diego, CA 92161",
            "zip_code": "92161",
            "created_at": "2023-12-21 03:27:40 +0500",
            "updated_at": "2023-12-21 03:27:40 +0500",
            "name": "San Diago",
            "deleted_at": null,
            "user_id": 46,
            "with_flow": false,
            "google_map_link": "https://maps.app.goo.gl/wsR17p3wwh7FdZ82A"
        },
        {
            "id": 69,
            "city": "Farmingdale",
            "state": "New York",
            "county": null,
            "primary_contact": "(123)123-1233",
            "address_line_two": "",
            "address_line_one": "435 Main Street",
            "zip_code": "11735",
            "created_at": "2024-01-03 04:09:24 +0500",
            "updated_at": "2024-02-16 22:57:56 +0500",
            "name": "Farmingdale",
            "deleted_at": null,
            "user_id": 46,
            "with_flow": false,
            "google_map_link": "https://maps.app.goo.gl/KXEDTVKyZV9nWJ5KA"
        },
        {
            "id": 76,
            "city": " Jersey City",
            "state": "New Jersey",
            "county": null,
            "primary_contact": "(201)111-1110",
            "address_line_two": "",
            "address_line_one": "159 Palisade Ave",
            "zip_code": "07306",
            "created_at": "2024-06-28 02:25:51 +0500",
            "updated_at": "2024-06-28 02:25:51 +0500",
            "name": "New Jersey",
            "deleted_at": null,
            "user_id": 46,
            "with_flow": false,
            "google_map_link": "https://maps.app.goo.gl/rpgUYWRediHVTnJf9"
        }
    ],
    "Providers": [
        {
            "id": 57,
            "status": "active",
            "first_name": "Fisrt. Available",
            "last_name": "Provider",
            "user_id": 46,
            "public_name": "Dr. Kushner's assistant",
            "email": "eman@digitalstandout.com",
            "created_at": "2023-09-29 22:30:43 +0500",
            "updated_at": "2024-07-10 19:44:11 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(747)207-2373",
            "select_all": false
        },
        {
            "id": 65,
            "status": "active",
            "first_name": "Dr.",
            "last_name": "Three",
            "user_id": 46,
            "public_name": "ID_65",
            "email": "doctor_five@dso.com",
            "created_at": "2023-12-21 04:19:13 +0500",
            "updated_at": "2024-01-03 03:54:06 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1234",
            "select_all": false
        },
        {
            "id": 66,
            "status": "active",
            "first_name": "Dr.",
            "last_name": "four",
            "user_id": 46,
            "public_name": "ID_66",
            "email": "doctor@dso.com",
            "created_at": "2023-12-21 23:14:39 +0500",
            "updated_at": "2024-01-03 03:54:38 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1234",
            "select_all": false
        },
        {
            "id": 71,
            "status": "active",
            "first_name": "Dr.",
            "last_name": "five",
            "user_id": 46,
            "public_name": "ID_71",
            "email": "doctor_seven@dso.com",
            "created_at": "2024-01-03 04:04:35 +0500",
            "updated_at": "2024-01-03 04:05:33 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1234",
            "select_all": false
        },
        {
            "id": 81,
            "status": "active",
            "first_name": "Dr.",
            "last_name": "six",
            "user_id": 46,
            "public_name": "ID_80",
            "email": "eman@digitalstandout.com",
            "created_at": "2024-06-28 02:11:29 +0500",
            "updated_at": "2024-06-28 02:11:29 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(321)321-3211",
            "select_all": false
        },
        {
            "id": 82,
            "status": "active",
            "first_name": "Dr. Rachel",
            "last_name": "DO",
            "user_id": 46,
            "public_name": "Board Certified Physician Assistant",
            "email": "doctor1@dso.com",
            "created_at": "2024-07-09 23:27:38 +0500",
            "updated_at": "2024-07-09 23:27:38 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)456-7891",
            "select_all": false
        },
        {
            "id": 83,
            "status": "active",
            "first_name": "Nikita farhadi",
            "last_name": "PA C",
            "user_id": 46,
            "public_name": "Board Certified Physician Assistant",
            "email": "doctor2@dso.com",
            "created_at": "2024-07-09 23:28:20 +0500",
            "updated_at": "2024-07-09 23:28:20 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1234",
            "select_all": false
        },
        {
            "id": 84,
            "status": "active",
            "first_name": "Esther Sobel",
            "last_name": "PA C",
            "user_id": 46,
            "public_name": "Physician Assistant",
            "email": "doctor3@dso.com",
            "created_at": "2024-07-09 23:29:32 +0500",
            "updated_at": "2024-07-09 23:29:32 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)456-7891",
            "select_all": false
        },
        {
            "id": 85,
            "status": "active",
            "first_name": "Maggie michael",
            "last_name": "PA C",
            "user_id": 46,
            "public_name": "Board Certified Physician Assistant",
            "email": "doctor4@dso.com",
            "created_at": "2024-07-09 23:34:51 +0500",
            "updated_at": "2024-07-09 23:34:51 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)456-7891",
            "select_all": false
        },
        {
            "id": 181,
            "status": "active",
            "first_name": "Demarcus",
            "last_name": "King",
            "user_id": 46,
            "public_name": "Quintin O'Connell",
            "email": "franklyn@pagac.org",
            "created_at": "2024-08-21 21:43:43 +0500",
            "updated_at": "2024-08-21 21:43:43 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 182,
            "status": "active",
            "first_name": "Terese",
            "last_name": "Dare",
            "user_id": 46,
            "public_name": "Mrs. Faye Grady",
            "email": "huey@davis.com",
            "created_at": "2024-08-21 21:44:21 +0500",
            "updated_at": "2024-08-21 21:44:21 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1234",
            "select_all": false
        },
        {
            "id": 183,
            "status": "active",
            "first_name": "Elvis",
            "last_name": "Zboncak",
            "user_id": 46,
            "public_name": "Gilberto Farrell",
            "email": "michele_windler@russel.org",
            "created_at": "2024-08-21 21:44:42 +0500",
            "updated_at": "2024-08-21 21:44:42 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)456-7890",
            "select_all": false
        },
        {
            "id": 184,
            "status": "active",
            "first_name": "Rudy",
            "last_name": "Huel",
            "user_id": 46,
            "public_name": "Reginia Emmerich",
            "email": "winnie@larson.info",
            "created_at": "2024-08-21 21:45:06 +0500",
            "updated_at": "2024-08-21 21:45:06 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)456-7890",
            "select_all": false
        },
        {
            "id": 185,
            "status": "active",
            "first_name": "Mariah",
            "last_name": "Moen",
            "user_id": 46,
            "public_name": "Andre Bartell",
            "email": "carlos@jakubowski-quigley.org",
            "created_at": "2024-08-21 21:45:35 +0500",
            "updated_at": "2024-08-21 21:45:35 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)456-7890",
            "select_all": false
        },
        {
            "id": 186,
            "status": "active",
            "first_name": "Rosalinda",
            "last_name": "Murray",
            "user_id": 46,
            "public_name": "Dwight Heaney",
            "email": "lorette@fisher.biz",
            "created_at": "2024-08-21 21:46:11 +0500",
            "updated_at": "2024-08-21 21:46:11 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)456-7890",
            "select_all": false
        },
        {
            "id": 187,
            "status": "active",
            "first_name": "Georgia",
            "last_name": "Anderson",
            "user_id": 46,
            "public_name": "Norine McCullough",
            "email": "lenard.hartmann@thompson.name",
            "created_at": "2024-08-21 22:03:11 +0500",
            "updated_at": "2024-08-21 22:03:11 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 188,
            "status": "active",
            "first_name": "Charles",
            "last_name": "McClure",
            "user_id": 46,
            "public_name": "Amb. Armand Lueilwitz",
            "email": "kathi.cronin@dietrich.info",
            "created_at": "2024-08-21 22:03:11 +0500",
            "updated_at": "2024-08-21 22:03:11 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 189,
            "status": "active",
            "first_name": "Chang",
            "last_name": "Murphy",
            "user_id": 46,
            "public_name": "King Connelly",
            "email": "luis_auer@ondricka.net",
            "created_at": "2024-08-21 22:03:11 +0500",
            "updated_at": "2024-08-21 22:03:11 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 190,
            "status": "active",
            "first_name": "Dwight",
            "last_name": "Kris",
            "user_id": 46,
            "public_name": "Chung Wisozk Ret.",
            "email": "berneice@halvorson-dach.com",
            "created_at": "2024-08-21 22:03:11 +0500",
            "updated_at": "2024-08-21 22:03:11 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 191,
            "status": "active",
            "first_name": "Kyle",
            "last_name": "Casper",
            "user_id": 46,
            "public_name": "Sen. Jed Kerluke",
            "email": "abby@marvin.name",
            "created_at": "2024-08-21 22:03:11 +0500",
            "updated_at": "2024-08-21 22:03:11 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 192,
            "status": "active",
            "first_name": "Howard",
            "last_name": "Mitchell",
            "user_id": 46,
            "public_name": "Norbert Bailey",
            "email": "neville@jaskolski.co",
            "created_at": "2024-08-21 22:03:11 +0500",
            "updated_at": "2024-08-21 22:03:11 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 193,
            "status": "active",
            "first_name": "Wei",
            "last_name": "Murphy",
            "user_id": 46,
            "public_name": "Mark Ebert",
            "email": "andres@reichert-huel.net",
            "created_at": "2024-08-21 22:03:12 +0500",
            "updated_at": "2024-08-21 22:03:12 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 194,
            "status": "active",
            "first_name": "Benita",
            "last_name": "Strosin",
            "user_id": 46,
            "public_name": "Dominique D'Amore MD",
            "email": "ardell_berge@reinger.name",
            "created_at": "2024-08-21 22:03:12 +0500",
            "updated_at": "2024-08-21 22:03:12 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 195,
            "status": "active",
            "first_name": "Ray",
            "last_name": "Klocko",
            "user_id": 46,
            "public_name": "Miss Tilda Gulgowski",
            "email": "whitley@gislason.co",
            "created_at": "2024-08-21 22:03:12 +0500",
            "updated_at": "2024-08-21 22:03:12 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        },
        {
            "id": 196,
            "status": "active",
            "first_name": "Anette",
            "last_name": "Nitzsche",
            "user_id": 46,
            "public_name": "Damon Funk",
            "email": "dillon.kuhn@mclaughlin.biz",
            "created_at": "2024-08-21 22:03:12 +0500",
            "updated_at": "2024-08-21 22:03:12 +0500",
            "deleted_at": null,
            "with_flow": false,
            "primary_phone": "(123)123-1236",
            "select_all": false
        }
    ],
    "Schedules": [
        {
            "id": 3754,
            "date": "2024-09-20",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:42 +0500",
            "updated_at": "2024-07-10 20:13:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-20",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-20 00:00:00 +0500",
            "checkout_time": "2024-09-20 08:00:00 +0500"
        },
        {
            "id": 4035,
            "date": "2024-09-20",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:12 +0500",
            "updated_at": "2024-07-10 20:24:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-20",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-20 00:00:00 +0500",
            "checkout_time": "2024-09-20 08:00:00 +0500"
        },
        {
            "id": 3880,
            "date": "2024-09-20",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:12 +0500",
            "updated_at": "2024-07-10 20:18:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-20",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-20 00:00:00 +0500",
            "checkout_time": "2024-09-20 08:00:00 +0500"
        },
        {
            "id": 3936,
            "date": "2024-09-20",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:24 +0500",
            "updated_at": "2024-07-10 20:20:24 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-20",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-20 00:00:00 +0500",
            "checkout_time": "2024-09-20 08:00:00 +0500"
        },
        {
            "id": 8429,
            "date": "2024-09-20",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-09-03 00:26:25 +0500",
            "updated_at": "2024-09-03 00:26:25 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-20",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-20 00:00:00 +0500",
            "checkout_time": "2024-09-20 08:00:00 +0500"
        },
        {
            "id": 4049,
            "date": "2024-09-21",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:46 +0500",
            "updated_at": "2024-07-10 20:24:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-21",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-21 00:00:00 +0500",
            "checkout_time": "2024-09-21 08:00:00 +0500"
        },
        {
            "id": 3894,
            "date": "2024-09-21",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:26 +0500",
            "updated_at": "2024-07-10 20:18:26 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-21",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-21 00:00:00 +0500",
            "checkout_time": "2024-09-21 08:00:00 +0500"
        },
        {
            "id": 4108,
            "date": "2024-09-21",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 21:00:31 +0500",
            "updated_at": "2024-07-10 21:00:31 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-21",
            "sch_doctor_ids": [
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-21 09:00:00 +0500",
            "checkout_time": "2024-09-21 17:00:00 +0500"
        },
        {
            "id": 3950,
            "date": "2024-09-21",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:50 +0500",
            "updated_at": "2024-07-10 20:20:50 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-21",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-21 00:00:00 +0500",
            "checkout_time": "2024-09-21 08:00:00 +0500"
        },
        {
            "id": 4121,
            "date": "2024-09-21",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 21:02:18 +0500",
            "updated_at": "2024-07-10 21:02:18 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-21",
            "sch_doctor_ids": [
                "",
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-21 10:00:00 +0500",
            "checkout_time": "2024-09-21 11:30:00 +0500"
        },
        {
            "id": 3908,
            "date": "2024-09-22",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:37 +0500",
            "updated_at": "2024-07-10 20:18:37 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-22",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-22 00:00:00 +0500",
            "checkout_time": "2024-09-22 08:00:00 +0500"
        },
        {
            "id": 3964,
            "date": "2024-09-22",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:46 +0500",
            "updated_at": "2024-07-10 20:21:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-22",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-22 00:00:00 +0500",
            "checkout_time": "2024-09-22 08:00:00 +0500"
        },
        {
            "id": 4063,
            "date": "2024-09-22",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:20 +0500",
            "updated_at": "2024-07-10 20:25:20 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-22",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-22 00:00:00 +0500",
            "checkout_time": "2024-09-22 08:00:00 +0500"
        },
        {
            "id": 3620,
            "date": "2024-09-23",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-06-26 02:24:39 +0500",
            "updated_at": "2024-06-26 02:24:39 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-23",
            "sch_doctor_ids": [
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-23 09:00:00 +0500",
            "checkout_time": "2024-09-23 17:00:00 +0500"
        },
        {
            "id": 3768,
            "date": "2024-09-23",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:59 +0500",
            "updated_at": "2024-07-10 20:13:59 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-23",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-23 00:00:00 +0500",
            "checkout_time": "2024-09-23 08:00:00 +0500"
        },
        {
            "id": 3824,
            "date": "2024-09-23",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:16:04 +0500",
            "updated_at": "2024-07-10 20:16:04 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-23",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-23 00:00:00 +0500",
            "checkout_time": "2024-09-23 08:00:00 +0500"
        },
        {
            "id": 4077,
            "date": "2024-09-23",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:42 +0500",
            "updated_at": "2024-07-10 20:25:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-23",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-23 00:00:00 +0500",
            "checkout_time": "2024-09-23 08:00:00 +0500"
        },
        {
            "id": 3978,
            "date": "2024-09-23",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:56 +0500",
            "updated_at": "2024-07-10 20:21:56 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-23",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-23 00:00:00 +0500",
            "checkout_time": "2024-09-23 08:00:00 +0500"
        },
        {
            "id": 3782,
            "date": "2024-09-24",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:25 +0500",
            "updated_at": "2024-07-10 20:14:25 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-24",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-09-24 00:00:00 +0500",
            "checkout_time": "2024-09-24 08:00:00 +0500"
        },
        {
            "id": 3838,
            "date": "2024-09-24",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:00 +0500",
            "updated_at": "2024-07-10 20:17:00 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-24",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-24 00:00:00 +0500",
            "checkout_time": "2024-09-24 08:00:00 +0500"
        },
        {
            "id": 4091,
            "date": "2024-09-24",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:26:07 +0500",
            "updated_at": "2024-07-10 20:26:07 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-24",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-24 00:00:00 +0500",
            "checkout_time": "2024-09-24 08:00:00 +0500"
        },
        {
            "id": 3993,
            "date": "2024-09-24",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:30 +0500",
            "updated_at": "2024-07-10 20:22:30 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-24",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-24 00:00:00 +0500",
            "checkout_time": "2024-09-24 08:00:00 +0500"
        },
        {
            "id": 3796,
            "date": "2024-09-25",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:42 +0500",
            "updated_at": "2024-07-10 20:14:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-25",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-09-25 00:00:00 +0500",
            "checkout_time": "2024-09-25 08:00:00 +0500"
        },
        {
            "id": 3852,
            "date": "2024-09-25",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:11 +0500",
            "updated_at": "2024-07-10 20:17:11 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-25",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-25 00:00:00 +0500",
            "checkout_time": "2024-09-25 08:00:00 +0500"
        },
        {
            "id": 4007,
            "date": "2024-09-25",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:42 +0500",
            "updated_at": "2024-07-10 20:22:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-25",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-25 00:00:00 +0500",
            "checkout_time": "2024-09-25 08:00:00 +0500"
        },
        {
            "id": 3741,
            "date": "2024-09-26",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:11:23 +0500",
            "updated_at": "2024-07-10 20:11:23 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-26",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-26 00:00:00 +0500",
            "checkout_time": "2024-09-26 08:00:00 +0500"
        },
        {
            "id": 4022,
            "date": "2024-09-26",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:23:54 +0500",
            "updated_at": "2024-07-10 20:23:54 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-26",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-26 00:00:00 +0500",
            "checkout_time": "2024-09-26 08:00:00 +0500"
        },
        {
            "id": 3810,
            "date": "2024-09-26",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:15:08 +0500",
            "updated_at": "2024-07-10 20:15:08 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-26",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-09-26 00:00:00 +0500",
            "checkout_time": "2024-09-26 08:00:00 +0500"
        },
        {
            "id": 3867,
            "date": "2024-09-26",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:02 +0500",
            "updated_at": "2024-07-10 20:18:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-26",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-26 00:00:00 +0500",
            "checkout_time": "2024-09-26 08:00:00 +0500"
        },
        {
            "id": 3923,
            "date": "2024-09-26",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:02 +0500",
            "updated_at": "2024-07-10 20:20:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-26",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-26 00:00:00 +0500",
            "checkout_time": "2024-09-26 08:00:00 +0500"
        },
        {
            "id": 3755,
            "date": "2024-09-27",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:42 +0500",
            "updated_at": "2024-07-10 20:13:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-27",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-27 00:00:00 +0500",
            "checkout_time": "2024-09-27 08:00:00 +0500"
        },
        {
            "id": 4036,
            "date": "2024-09-27",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:12 +0500",
            "updated_at": "2024-07-10 20:24:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-27",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-27 00:00:00 +0500",
            "checkout_time": "2024-09-27 08:00:00 +0500"
        },
        {
            "id": 3881,
            "date": "2024-09-27",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:12 +0500",
            "updated_at": "2024-07-10 20:18:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-27",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-27 00:00:00 +0500",
            "checkout_time": "2024-09-27 08:00:00 +0500"
        },
        {
            "id": 3937,
            "date": "2024-09-27",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:24 +0500",
            "updated_at": "2024-07-10 20:20:24 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-27",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-27 00:00:00 +0500",
            "checkout_time": "2024-09-27 08:00:00 +0500"
        },
        {
            "id": 4050,
            "date": "2024-09-28",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:46 +0500",
            "updated_at": "2024-07-10 20:24:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-28",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-28 00:00:00 +0500",
            "checkout_time": "2024-09-28 08:00:00 +0500"
        },
        {
            "id": 3895,
            "date": "2024-09-28",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:26 +0500",
            "updated_at": "2024-07-10 20:18:26 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-28",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-28 00:00:00 +0500",
            "checkout_time": "2024-09-28 08:00:00 +0500"
        },
        {
            "id": 3951,
            "date": "2024-09-28",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:50 +0500",
            "updated_at": "2024-07-10 20:20:50 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-28",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-28 00:00:00 +0500",
            "checkout_time": "2024-09-28 08:00:00 +0500"
        },
        {
            "id": 4109,
            "date": "2024-09-28",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 21:00:31 +0500",
            "updated_at": "2024-07-10 21:00:31 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-28",
            "sch_doctor_ids": [
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-28 09:00:00 +0500",
            "checkout_time": "2024-09-28 17:00:00 +0500"
        },
        {
            "id": 4122,
            "date": "2024-09-28",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 21:02:18 +0500",
            "updated_at": "2024-07-10 21:02:18 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-28",
            "sch_doctor_ids": [
                "",
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-28 10:00:00 +0500",
            "checkout_time": "2024-09-28 11:30:00 +0500"
        },
        {
            "id": 3909,
            "date": "2024-09-29",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:37 +0500",
            "updated_at": "2024-07-10 20:18:37 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-29",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-29 00:00:00 +0500",
            "checkout_time": "2024-09-29 08:00:00 +0500"
        },
        {
            "id": 3965,
            "date": "2024-09-29",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:46 +0500",
            "updated_at": "2024-07-10 20:21:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-29",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-29 00:00:00 +0500",
            "checkout_time": "2024-09-29 08:00:00 +0500"
        },
        {
            "id": 4064,
            "date": "2024-09-29",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:20 +0500",
            "updated_at": "2024-07-10 20:25:20 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-29",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-29 00:00:00 +0500",
            "checkout_time": "2024-09-29 08:00:00 +0500"
        },
        {
            "id": 3621,
            "date": "2024-09-30",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-06-26 02:24:39 +0500",
            "updated_at": "2024-06-26 02:24:39 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-30",
            "sch_doctor_ids": [
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-30 09:00:00 +0500",
            "checkout_time": "2024-09-30 17:00:00 +0500"
        },
        {
            "id": 3769,
            "date": "2024-09-30",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:59 +0500",
            "updated_at": "2024-07-10 20:13:59 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-30",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-30 00:00:00 +0500",
            "checkout_time": "2024-09-30 08:00:00 +0500"
        },
        {
            "id": 3825,
            "date": "2024-09-30",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:16:04 +0500",
            "updated_at": "2024-07-10 20:16:04 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-30",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-09-30 00:00:00 +0500",
            "checkout_time": "2024-09-30 08:00:00 +0500"
        },
        {
            "id": 4078,
            "date": "2024-09-30",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:42 +0500",
            "updated_at": "2024-07-10 20:25:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-30",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-09-30 00:00:00 +0500",
            "checkout_time": "2024-09-30 08:00:00 +0500"
        },
        {
            "id": 3979,
            "date": "2024-09-30",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:56 +0500",
            "updated_at": "2024-07-10 20:21:56 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-09-30",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-09-30 00:00:00 +0500",
            "checkout_time": "2024-09-30 08:00:00 +0500"
        },
        {
            "id": 3783,
            "date": "2024-10-01",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:25 +0500",
            "updated_at": "2024-07-10 20:14:25 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-01",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-01 00:00:00 +0500",
            "checkout_time": "2024-10-01 08:00:00 +0500"
        },
        {
            "id": 3839,
            "date": "2024-10-01",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:00 +0500",
            "updated_at": "2024-07-10 20:17:00 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-01",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-01 00:00:00 +0500",
            "checkout_time": "2024-10-01 08:00:00 +0500"
        },
        {
            "id": 4092,
            "date": "2024-10-01",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:26:07 +0500",
            "updated_at": "2024-07-10 20:26:07 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-01",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-01 00:00:00 +0500",
            "checkout_time": "2024-10-01 08:00:00 +0500"
        },
        {
            "id": 3994,
            "date": "2024-10-01",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:30 +0500",
            "updated_at": "2024-07-10 20:22:30 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-01",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-01 00:00:00 +0500",
            "checkout_time": "2024-10-01 08:00:00 +0500"
        },
        {
            "id": 3797,
            "date": "2024-10-02",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:42 +0500",
            "updated_at": "2024-07-10 20:14:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-02",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-02 00:00:00 +0500",
            "checkout_time": "2024-10-02 08:00:00 +0500"
        },
        {
            "id": 3853,
            "date": "2024-10-02",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:11 +0500",
            "updated_at": "2024-07-10 20:17:11 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-02",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-02 00:00:00 +0500",
            "checkout_time": "2024-10-02 08:00:00 +0500"
        },
        {
            "id": 4008,
            "date": "2024-10-02",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:42 +0500",
            "updated_at": "2024-07-10 20:22:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-02",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-02 00:00:00 +0500",
            "checkout_time": "2024-10-02 08:00:00 +0500"
        },
        {
            "id": 3742,
            "date": "2024-10-03",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:11:23 +0500",
            "updated_at": "2024-07-10 20:11:23 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-03",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-03 00:00:00 +0500",
            "checkout_time": "2024-10-03 08:00:00 +0500"
        },
        {
            "id": 4023,
            "date": "2024-10-03",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:23:54 +0500",
            "updated_at": "2024-07-10 20:23:54 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-03",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-03 00:00:00 +0500",
            "checkout_time": "2024-10-03 08:00:00 +0500"
        },
        {
            "id": 3811,
            "date": "2024-10-03",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:15:08 +0500",
            "updated_at": "2024-07-10 20:15:08 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-03",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-03 00:00:00 +0500",
            "checkout_time": "2024-10-03 08:00:00 +0500"
        },
        {
            "id": 3868,
            "date": "2024-10-03",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:02 +0500",
            "updated_at": "2024-07-10 20:18:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-03",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-03 00:00:00 +0500",
            "checkout_time": "2024-10-03 08:00:00 +0500"
        },
        {
            "id": 3924,
            "date": "2024-10-03",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:02 +0500",
            "updated_at": "2024-07-10 20:20:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-03",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-03 00:00:00 +0500",
            "checkout_time": "2024-10-03 08:00:00 +0500"
        },
        {
            "id": 3756,
            "date": "2024-10-04",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:42 +0500",
            "updated_at": "2024-07-10 20:13:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-04",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-04 00:00:00 +0500",
            "checkout_time": "2024-10-04 08:00:00 +0500"
        },
        {
            "id": 4037,
            "date": "2024-10-04",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:12 +0500",
            "updated_at": "2024-07-10 20:24:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-04",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-04 00:00:00 +0500",
            "checkout_time": "2024-10-04 08:00:00 +0500"
        },
        {
            "id": 3882,
            "date": "2024-10-04",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:12 +0500",
            "updated_at": "2024-07-10 20:18:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-04",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-04 00:00:00 +0500",
            "checkout_time": "2024-10-04 08:00:00 +0500"
        },
        {
            "id": 3938,
            "date": "2024-10-04",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:24 +0500",
            "updated_at": "2024-07-10 20:20:24 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-04",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-04 00:00:00 +0500",
            "checkout_time": "2024-10-04 08:00:00 +0500"
        },
        {
            "id": 4051,
            "date": "2024-10-05",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:46 +0500",
            "updated_at": "2024-07-10 20:24:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-05",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-05 00:00:00 +0500",
            "checkout_time": "2024-10-05 08:00:00 +0500"
        },
        {
            "id": 3896,
            "date": "2024-10-05",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:26 +0500",
            "updated_at": "2024-07-10 20:18:26 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-05",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-05 00:00:00 +0500",
            "checkout_time": "2024-10-05 08:00:00 +0500"
        },
        {
            "id": 3952,
            "date": "2024-10-05",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:50 +0500",
            "updated_at": "2024-07-10 20:20:50 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-05",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-05 00:00:00 +0500",
            "checkout_time": "2024-10-05 08:00:00 +0500"
        },
        {
            "id": 4110,
            "date": "2024-10-05",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 21:00:31 +0500",
            "updated_at": "2024-07-10 21:00:31 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-05",
            "sch_doctor_ids": [
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-05 09:00:00 +0500",
            "checkout_time": "2024-10-05 17:00:00 +0500"
        },
        {
            "id": 4123,
            "date": "2024-10-05",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 21:02:18 +0500",
            "updated_at": "2024-07-10 21:02:18 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-05",
            "sch_doctor_ids": [
                "",
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-05 10:00:00 +0500",
            "checkout_time": "2024-10-05 11:30:00 +0500"
        },
        {
            "id": 3910,
            "date": "2024-10-06",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:37 +0500",
            "updated_at": "2024-07-10 20:18:37 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-06",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-06 00:00:00 +0500",
            "checkout_time": "2024-10-06 08:00:00 +0500"
        },
        {
            "id": 3966,
            "date": "2024-10-06",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:46 +0500",
            "updated_at": "2024-07-10 20:21:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-06",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-06 00:00:00 +0500",
            "checkout_time": "2024-10-06 08:00:00 +0500"
        },
        {
            "id": 4065,
            "date": "2024-10-06",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:20 +0500",
            "updated_at": "2024-07-10 20:25:20 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-06",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-06 00:00:00 +0500",
            "checkout_time": "2024-10-06 08:00:00 +0500"
        },
        {
            "id": 3770,
            "date": "2024-10-07",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:59 +0500",
            "updated_at": "2024-07-10 20:13:59 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-07",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-07 00:00:00 +0500",
            "checkout_time": "2024-10-07 08:00:00 +0500"
        },
        {
            "id": 3826,
            "date": "2024-10-07",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:16:04 +0500",
            "updated_at": "2024-07-10 20:16:04 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-07",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-07 00:00:00 +0500",
            "checkout_time": "2024-10-07 08:00:00 +0500"
        },
        {
            "id": 4079,
            "date": "2024-10-07",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:42 +0500",
            "updated_at": "2024-07-10 20:25:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-07",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-07 00:00:00 +0500",
            "checkout_time": "2024-10-07 08:00:00 +0500"
        },
        {
            "id": 3980,
            "date": "2024-10-07",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:56 +0500",
            "updated_at": "2024-07-10 20:21:56 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-07",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-07 00:00:00 +0500",
            "checkout_time": "2024-10-07 08:00:00 +0500"
        },
        {
            "id": 3784,
            "date": "2024-10-08",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:25 +0500",
            "updated_at": "2024-07-10 20:14:25 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-08",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-08 00:00:00 +0500",
            "checkout_time": "2024-10-08 08:00:00 +0500"
        },
        {
            "id": 3840,
            "date": "2024-10-08",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:00 +0500",
            "updated_at": "2024-07-10 20:17:00 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-08",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-08 00:00:00 +0500",
            "checkout_time": "2024-10-08 08:00:00 +0500"
        },
        {
            "id": 4093,
            "date": "2024-10-08",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:26:07 +0500",
            "updated_at": "2024-07-10 20:26:07 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-08",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-08 00:00:00 +0500",
            "checkout_time": "2024-10-08 08:00:00 +0500"
        },
        {
            "id": 3995,
            "date": "2024-10-08",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:30 +0500",
            "updated_at": "2024-07-10 20:22:30 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-08",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-08 00:00:00 +0500",
            "checkout_time": "2024-10-08 08:00:00 +0500"
        },
        {
            "id": 3798,
            "date": "2024-10-09",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:42 +0500",
            "updated_at": "2024-07-10 20:14:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-09",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-09 00:00:00 +0500",
            "checkout_time": "2024-10-09 08:00:00 +0500"
        },
        {
            "id": 3854,
            "date": "2024-10-09",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:11 +0500",
            "updated_at": "2024-07-10 20:17:11 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-09",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-09 00:00:00 +0500",
            "checkout_time": "2024-10-09 08:00:00 +0500"
        },
        {
            "id": 4009,
            "date": "2024-10-09",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:42 +0500",
            "updated_at": "2024-07-10 20:22:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-09",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-09 00:00:00 +0500",
            "checkout_time": "2024-10-09 08:00:00 +0500"
        },
        {
            "id": 3743,
            "date": "2024-10-10",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:11:23 +0500",
            "updated_at": "2024-07-10 20:11:23 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-10",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-10 00:00:00 +0500",
            "checkout_time": "2024-10-10 08:00:00 +0500"
        },
        {
            "id": 4024,
            "date": "2024-10-10",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:23:54 +0500",
            "updated_at": "2024-07-10 20:23:54 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-10",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-10 00:00:00 +0500",
            "checkout_time": "2024-10-10 08:00:00 +0500"
        },
        {
            "id": 3812,
            "date": "2024-10-10",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:15:08 +0500",
            "updated_at": "2024-07-10 20:15:08 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-10",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-10 00:00:00 +0500",
            "checkout_time": "2024-10-10 08:00:00 +0500"
        },
        {
            "id": 3869,
            "date": "2024-10-10",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:02 +0500",
            "updated_at": "2024-07-10 20:18:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-10",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-10 00:00:00 +0500",
            "checkout_time": "2024-10-10 08:00:00 +0500"
        },
        {
            "id": 3925,
            "date": "2024-10-10",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:02 +0500",
            "updated_at": "2024-07-10 20:20:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-10",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-10 00:00:00 +0500",
            "checkout_time": "2024-10-10 08:00:00 +0500"
        },
        {
            "id": 3757,
            "date": "2024-10-11",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:42 +0500",
            "updated_at": "2024-07-10 20:13:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-11",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-11 00:00:00 +0500",
            "checkout_time": "2024-10-11 08:00:00 +0500"
        },
        {
            "id": 4038,
            "date": "2024-10-11",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:12 +0500",
            "updated_at": "2024-07-10 20:24:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-11",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-11 00:00:00 +0500",
            "checkout_time": "2024-10-11 08:00:00 +0500"
        },
        {
            "id": 3883,
            "date": "2024-10-11",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:12 +0500",
            "updated_at": "2024-07-10 20:18:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-11",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-11 00:00:00 +0500",
            "checkout_time": "2024-10-11 08:00:00 +0500"
        },
        {
            "id": 3939,
            "date": "2024-10-11",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:24 +0500",
            "updated_at": "2024-07-10 20:20:24 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-11",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-11 00:00:00 +0500",
            "checkout_time": "2024-10-11 08:00:00 +0500"
        },
        {
            "id": 4052,
            "date": "2024-10-12",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:47 +0500",
            "updated_at": "2024-07-10 20:24:47 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-12",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-12 00:00:00 +0500",
            "checkout_time": "2024-10-12 08:00:00 +0500"
        },
        {
            "id": 3897,
            "date": "2024-10-12",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:26 +0500",
            "updated_at": "2024-07-10 20:18:26 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-12",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-12 00:00:00 +0500",
            "checkout_time": "2024-10-12 08:00:00 +0500"
        },
        {
            "id": 3953,
            "date": "2024-10-12",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:50 +0500",
            "updated_at": "2024-07-10 20:20:50 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-12",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-12 00:00:00 +0500",
            "checkout_time": "2024-10-12 08:00:00 +0500"
        },
        {
            "id": 4111,
            "date": "2024-10-12",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 21:00:31 +0500",
            "updated_at": "2024-07-10 21:00:31 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-12",
            "sch_doctor_ids": [
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-12 09:00:00 +0500",
            "checkout_time": "2024-10-12 17:00:00 +0500"
        },
        {
            "id": 4124,
            "date": "2024-10-12",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 21:02:18 +0500",
            "updated_at": "2024-07-10 21:02:18 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-12",
            "sch_doctor_ids": [
                "",
                "57"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-12 10:00:00 +0500",
            "checkout_time": "2024-10-12 11:30:00 +0500"
        },
        {
            "id": 3911,
            "date": "2024-10-13",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:37 +0500",
            "updated_at": "2024-07-10 20:18:37 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-13",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-13 00:00:00 +0500",
            "checkout_time": "2024-10-13 08:00:00 +0500"
        },
        {
            "id": 3967,
            "date": "2024-10-13",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:46 +0500",
            "updated_at": "2024-07-10 20:21:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-13",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-13 00:00:00 +0500",
            "checkout_time": "2024-10-13 08:00:00 +0500"
        },
        {
            "id": 4066,
            "date": "2024-10-13",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:20 +0500",
            "updated_at": "2024-07-10 20:25:20 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-13",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-13 00:00:00 +0500",
            "checkout_time": "2024-10-13 08:00:00 +0500"
        },
        {
            "id": 3771,
            "date": "2024-10-14",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:59 +0500",
            "updated_at": "2024-07-10 20:13:59 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-14",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-14 00:00:00 +0500",
            "checkout_time": "2024-10-14 08:00:00 +0500"
        },
        {
            "id": 3827,
            "date": "2024-10-14",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:16:04 +0500",
            "updated_at": "2024-07-10 20:16:04 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-14",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-14 00:00:00 +0500",
            "checkout_time": "2024-10-14 08:00:00 +0500"
        },
        {
            "id": 4080,
            "date": "2024-10-14",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:42 +0500",
            "updated_at": "2024-07-10 20:25:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-14",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-14 00:00:00 +0500",
            "checkout_time": "2024-10-14 08:00:00 +0500"
        },
        {
            "id": 3981,
            "date": "2024-10-14",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:56 +0500",
            "updated_at": "2024-07-10 20:21:56 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-14",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-14 00:00:00 +0500",
            "checkout_time": "2024-10-14 08:00:00 +0500"
        },
        {
            "id": 3785,
            "date": "2024-10-15",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:25 +0500",
            "updated_at": "2024-07-10 20:14:25 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-15",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-15 00:00:00 +0500",
            "checkout_time": "2024-10-15 08:00:00 +0500"
        },
        {
            "id": 3841,
            "date": "2024-10-15",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:00 +0500",
            "updated_at": "2024-07-10 20:17:00 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-15",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-15 00:00:00 +0500",
            "checkout_time": "2024-10-15 08:00:00 +0500"
        },
        {
            "id": 4094,
            "date": "2024-10-15",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:26:07 +0500",
            "updated_at": "2024-07-10 20:26:07 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-15",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-15 00:00:00 +0500",
            "checkout_time": "2024-10-15 08:00:00 +0500"
        },
        {
            "id": 3996,
            "date": "2024-10-15",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:30 +0500",
            "updated_at": "2024-07-10 20:22:30 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-15",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-15 00:00:00 +0500",
            "checkout_time": "2024-10-15 08:00:00 +0500"
        },
        {
            "id": 3799,
            "date": "2024-10-16",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:42 +0500",
            "updated_at": "2024-07-10 20:14:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-16",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-16 00:00:00 +0500",
            "checkout_time": "2024-10-16 08:00:00 +0500"
        },
        {
            "id": 3855,
            "date": "2024-10-16",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:11 +0500",
            "updated_at": "2024-07-10 20:17:11 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-16",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-16 00:00:00 +0500",
            "checkout_time": "2024-10-16 08:00:00 +0500"
        },
        {
            "id": 4010,
            "date": "2024-10-16",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:42 +0500",
            "updated_at": "2024-07-10 20:22:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-16",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-16 00:00:00 +0500",
            "checkout_time": "2024-10-16 08:00:00 +0500"
        },
        {
            "id": 3744,
            "date": "2024-10-17",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:11:23 +0500",
            "updated_at": "2024-07-10 20:11:23 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-17",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-17 00:00:00 +0500",
            "checkout_time": "2024-10-17 08:00:00 +0500"
        },
        {
            "id": 4025,
            "date": "2024-10-17",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:23:54 +0500",
            "updated_at": "2024-07-10 20:23:54 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-17",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-17 00:00:00 +0500",
            "checkout_time": "2024-10-17 08:00:00 +0500"
        },
        {
            "id": 3813,
            "date": "2024-10-17",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:15:08 +0500",
            "updated_at": "2024-07-10 20:15:08 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-17",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-17 00:00:00 +0500",
            "checkout_time": "2024-10-17 08:00:00 +0500"
        },
        {
            "id": 3870,
            "date": "2024-10-17",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:02 +0500",
            "updated_at": "2024-07-10 20:18:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-17",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-17 00:00:00 +0500",
            "checkout_time": "2024-10-17 08:00:00 +0500"
        },
        {
            "id": 3926,
            "date": "2024-10-17",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:02 +0500",
            "updated_at": "2024-07-10 20:20:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-17",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-17 00:00:00 +0500",
            "checkout_time": "2024-10-17 08:00:00 +0500"
        },
        {
            "id": 3758,
            "date": "2024-10-18",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:42 +0500",
            "updated_at": "2024-07-10 20:13:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-18",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-18 00:00:00 +0500",
            "checkout_time": "2024-10-18 08:00:00 +0500"
        },
        {
            "id": 4039,
            "date": "2024-10-18",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:12 +0500",
            "updated_at": "2024-07-10 20:24:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-18",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-18 00:00:00 +0500",
            "checkout_time": "2024-10-18 08:00:00 +0500"
        },
        {
            "id": 3884,
            "date": "2024-10-18",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:12 +0500",
            "updated_at": "2024-07-10 20:18:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-18",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-18 00:00:00 +0500",
            "checkout_time": "2024-10-18 08:00:00 +0500"
        },
        {
            "id": 3940,
            "date": "2024-10-18",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:24 +0500",
            "updated_at": "2024-07-10 20:20:24 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-18",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-18 00:00:00 +0500",
            "checkout_time": "2024-10-18 08:00:00 +0500"
        },
        {
            "id": 4053,
            "date": "2024-10-19",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:47 +0500",
            "updated_at": "2024-07-10 20:24:47 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-19",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-19 00:00:00 +0500",
            "checkout_time": "2024-10-19 08:00:00 +0500"
        },
        {
            "id": 3898,
            "date": "2024-10-19",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:26 +0500",
            "updated_at": "2024-07-10 20:18:26 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-19",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-19 00:00:00 +0500",
            "checkout_time": "2024-10-19 08:00:00 +0500"
        },
        {
            "id": 3954,
            "date": "2024-10-19",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:50 +0500",
            "updated_at": "2024-07-10 20:20:50 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-19",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-19 00:00:00 +0500",
            "checkout_time": "2024-10-19 08:00:00 +0500"
        },
        {
            "id": 3912,
            "date": "2024-10-20",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:37 +0500",
            "updated_at": "2024-07-10 20:18:37 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-20",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-20 00:00:00 +0500",
            "checkout_time": "2024-10-20 08:00:00 +0500"
        },
        {
            "id": 3968,
            "date": "2024-10-20",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:46 +0500",
            "updated_at": "2024-07-10 20:21:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-20",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-20 00:00:00 +0500",
            "checkout_time": "2024-10-20 08:00:00 +0500"
        },
        {
            "id": 4067,
            "date": "2024-10-20",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:20 +0500",
            "updated_at": "2024-07-10 20:25:20 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-20",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-20 00:00:00 +0500",
            "checkout_time": "2024-10-20 08:00:00 +0500"
        },
        {
            "id": 3772,
            "date": "2024-10-21",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:59 +0500",
            "updated_at": "2024-07-10 20:13:59 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-21",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-21 00:00:00 +0500",
            "checkout_time": "2024-10-21 08:00:00 +0500"
        },
        {
            "id": 3828,
            "date": "2024-10-21",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:16:04 +0500",
            "updated_at": "2024-07-10 20:16:04 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-21",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-21 00:00:00 +0500",
            "checkout_time": "2024-10-21 08:00:00 +0500"
        },
        {
            "id": 4081,
            "date": "2024-10-21",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:42 +0500",
            "updated_at": "2024-07-10 20:25:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-21",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-21 00:00:00 +0500",
            "checkout_time": "2024-10-21 08:00:00 +0500"
        },
        {
            "id": 3982,
            "date": "2024-10-21",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:56 +0500",
            "updated_at": "2024-07-10 20:21:56 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-21",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-21 00:00:00 +0500",
            "checkout_time": "2024-10-21 08:00:00 +0500"
        },
        {
            "id": 3786,
            "date": "2024-10-22",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:25 +0500",
            "updated_at": "2024-07-10 20:14:25 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-22",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-22 00:00:00 +0500",
            "checkout_time": "2024-10-22 08:00:00 +0500"
        },
        {
            "id": 3842,
            "date": "2024-10-22",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:00 +0500",
            "updated_at": "2024-07-10 20:17:00 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-22",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-22 00:00:00 +0500",
            "checkout_time": "2024-10-22 08:00:00 +0500"
        },
        {
            "id": 4095,
            "date": "2024-10-22",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:26:07 +0500",
            "updated_at": "2024-07-10 20:26:07 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-22",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-22 00:00:00 +0500",
            "checkout_time": "2024-10-22 08:00:00 +0500"
        },
        {
            "id": 3997,
            "date": "2024-10-22",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:30 +0500",
            "updated_at": "2024-07-10 20:22:30 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-22",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-22 00:00:00 +0500",
            "checkout_time": "2024-10-22 08:00:00 +0500"
        },
        {
            "id": 3800,
            "date": "2024-10-23",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:42 +0500",
            "updated_at": "2024-07-10 20:14:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-23",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-23 00:00:00 +0500",
            "checkout_time": "2024-10-23 08:00:00 +0500"
        },
        {
            "id": 3856,
            "date": "2024-10-23",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:11 +0500",
            "updated_at": "2024-07-10 20:17:11 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-23",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-23 00:00:00 +0500",
            "checkout_time": "2024-10-23 08:00:00 +0500"
        },
        {
            "id": 4011,
            "date": "2024-10-23",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:42 +0500",
            "updated_at": "2024-07-10 20:22:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-23",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-23 00:00:00 +0500",
            "checkout_time": "2024-10-23 08:00:00 +0500"
        },
        {
            "id": 3745,
            "date": "2024-10-24",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:11:23 +0500",
            "updated_at": "2024-07-10 20:11:23 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-24",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-24 00:00:00 +0500",
            "checkout_time": "2024-10-24 08:00:00 +0500"
        },
        {
            "id": 4026,
            "date": "2024-10-24",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:23:54 +0500",
            "updated_at": "2024-07-10 20:23:54 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-24",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-24 00:00:00 +0500",
            "checkout_time": "2024-10-24 08:00:00 +0500"
        },
        {
            "id": 3814,
            "date": "2024-10-24",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:15:08 +0500",
            "updated_at": "2024-07-10 20:15:08 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-24",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-24 00:00:00 +0500",
            "checkout_time": "2024-10-24 08:00:00 +0500"
        },
        {
            "id": 3871,
            "date": "2024-10-24",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:02 +0500",
            "updated_at": "2024-07-10 20:18:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-24",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-24 00:00:00 +0500",
            "checkout_time": "2024-10-24 08:00:00 +0500"
        },
        {
            "id": 3927,
            "date": "2024-10-24",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:02 +0500",
            "updated_at": "2024-07-10 20:20:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-24",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-24 00:00:00 +0500",
            "checkout_time": "2024-10-24 08:00:00 +0500"
        },
        {
            "id": 3759,
            "date": "2024-10-25",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:42 +0500",
            "updated_at": "2024-07-10 20:13:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-25",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-25 00:00:00 +0500",
            "checkout_time": "2024-10-25 08:00:00 +0500"
        },
        {
            "id": 4040,
            "date": "2024-10-25",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:12 +0500",
            "updated_at": "2024-07-10 20:24:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-25",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-25 00:00:00 +0500",
            "checkout_time": "2024-10-25 08:00:00 +0500"
        },
        {
            "id": 3885,
            "date": "2024-10-25",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:12 +0500",
            "updated_at": "2024-07-10 20:18:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-25",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-25 00:00:00 +0500",
            "checkout_time": "2024-10-25 08:00:00 +0500"
        },
        {
            "id": 3941,
            "date": "2024-10-25",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:24 +0500",
            "updated_at": "2024-07-10 20:20:24 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-25",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-25 00:00:00 +0500",
            "checkout_time": "2024-10-25 08:00:00 +0500"
        },
        {
            "id": 4054,
            "date": "2024-10-26",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:47 +0500",
            "updated_at": "2024-07-10 20:24:47 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-26",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-26 00:00:00 +0500",
            "checkout_time": "2024-10-26 08:00:00 +0500"
        },
        {
            "id": 3899,
            "date": "2024-10-26",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:26 +0500",
            "updated_at": "2024-07-10 20:18:26 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-26",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-26 00:00:00 +0500",
            "checkout_time": "2024-10-26 08:00:00 +0500"
        },
        {
            "id": 3955,
            "date": "2024-10-26",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:50 +0500",
            "updated_at": "2024-07-10 20:20:50 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-26",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-26 00:00:00 +0500",
            "checkout_time": "2024-10-26 08:00:00 +0500"
        },
        {
            "id": 3913,
            "date": "2024-10-27",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:37 +0500",
            "updated_at": "2024-07-10 20:18:37 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-27",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-27 00:00:00 +0500",
            "checkout_time": "2024-10-27 08:00:00 +0500"
        },
        {
            "id": 3969,
            "date": "2024-10-27",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:46 +0500",
            "updated_at": "2024-07-10 20:21:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-27",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-27 00:00:00 +0500",
            "checkout_time": "2024-10-27 08:00:00 +0500"
        },
        {
            "id": 4068,
            "date": "2024-10-27",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:20 +0500",
            "updated_at": "2024-07-10 20:25:20 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-27",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-27 00:00:00 +0500",
            "checkout_time": "2024-10-27 08:00:00 +0500"
        },
        {
            "id": 3773,
            "date": "2024-10-28",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:59 +0500",
            "updated_at": "2024-07-10 20:13:59 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-28",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-28 00:00:00 +0500",
            "checkout_time": "2024-10-28 08:00:00 +0500"
        },
        {
            "id": 3829,
            "date": "2024-10-28",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:16:04 +0500",
            "updated_at": "2024-07-10 20:16:04 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-28",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-28 00:00:00 +0500",
            "checkout_time": "2024-10-28 08:00:00 +0500"
        },
        {
            "id": 4082,
            "date": "2024-10-28",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:42 +0500",
            "updated_at": "2024-07-10 20:25:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-28",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-28 00:00:00 +0500",
            "checkout_time": "2024-10-28 08:00:00 +0500"
        },
        {
            "id": 3983,
            "date": "2024-10-28",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:56 +0500",
            "updated_at": "2024-07-10 20:21:56 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-28",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-28 00:00:00 +0500",
            "checkout_time": "2024-10-28 08:00:00 +0500"
        },
        {
            "id": 3787,
            "date": "2024-10-29",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:25 +0500",
            "updated_at": "2024-07-10 20:14:25 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-29",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-29 00:00:00 +0500",
            "checkout_time": "2024-10-29 08:00:00 +0500"
        },
        {
            "id": 3843,
            "date": "2024-10-29",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:00 +0500",
            "updated_at": "2024-07-10 20:17:00 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-29",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-29 00:00:00 +0500",
            "checkout_time": "2024-10-29 08:00:00 +0500"
        },
        {
            "id": 4096,
            "date": "2024-10-29",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:26:07 +0500",
            "updated_at": "2024-07-10 20:26:07 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-29",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-29 00:00:00 +0500",
            "checkout_time": "2024-10-29 08:00:00 +0500"
        },
        {
            "id": 3998,
            "date": "2024-10-29",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:30 +0500",
            "updated_at": "2024-07-10 20:22:30 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-29",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-29 00:00:00 +0500",
            "checkout_time": "2024-10-29 08:00:00 +0500"
        },
        {
            "id": 3801,
            "date": "2024-10-30",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:42 +0500",
            "updated_at": "2024-07-10 20:14:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-30",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-30 00:00:00 +0500",
            "checkout_time": "2024-10-30 08:00:00 +0500"
        },
        {
            "id": 3857,
            "date": "2024-10-30",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:11 +0500",
            "updated_at": "2024-07-10 20:17:11 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-30",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-30 00:00:00 +0500",
            "checkout_time": "2024-10-30 08:00:00 +0500"
        },
        {
            "id": 4012,
            "date": "2024-10-30",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:42 +0500",
            "updated_at": "2024-07-10 20:22:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-30",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-30 00:00:00 +0500",
            "checkout_time": "2024-10-30 08:00:00 +0500"
        },
        {
            "id": 3746,
            "date": "2024-10-31",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:11:23 +0500",
            "updated_at": "2024-07-10 20:11:23 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-31",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-10-31 00:00:00 +0500",
            "checkout_time": "2024-10-31 08:00:00 +0500"
        },
        {
            "id": 4027,
            "date": "2024-10-31",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:23:54 +0500",
            "updated_at": "2024-07-10 20:23:54 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-31",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-31 00:00:00 +0500",
            "checkout_time": "2024-10-31 08:00:00 +0500"
        },
        {
            "id": 3815,
            "date": "2024-10-31",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:15:08 +0500",
            "updated_at": "2024-07-10 20:15:08 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-31",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-10-31 00:00:00 +0500",
            "checkout_time": "2024-10-31 08:00:00 +0500"
        },
        {
            "id": 3872,
            "date": "2024-10-31",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:02 +0500",
            "updated_at": "2024-07-10 20:18:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-31",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-10-31 00:00:00 +0500",
            "checkout_time": "2024-10-31 08:00:00 +0500"
        },
        {
            "id": 3928,
            "date": "2024-10-31",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:02 +0500",
            "updated_at": "2024-07-10 20:20:02 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-10-31",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-10-31 00:00:00 +0500",
            "checkout_time": "2024-10-31 08:00:00 +0500"
        },
        {
            "id": 3760,
            "date": "2024-11-01",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:42 +0500",
            "updated_at": "2024-07-10 20:13:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-01",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-11-01 00:00:00 +0500",
            "checkout_time": "2024-11-01 08:00:00 +0500"
        },
        {
            "id": 4041,
            "date": "2024-11-01",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:12 +0500",
            "updated_at": "2024-07-10 20:24:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-01",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-11-01 00:00:00 +0500",
            "checkout_time": "2024-11-01 08:00:00 +0500"
        },
        {
            "id": 3886,
            "date": "2024-11-01",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:12 +0500",
            "updated_at": "2024-07-10 20:18:12 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-01",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-11-01 00:00:00 +0500",
            "checkout_time": "2024-11-01 08:00:00 +0500"
        },
        {
            "id": 3942,
            "date": "2024-11-01",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:24 +0500",
            "updated_at": "2024-07-10 20:20:24 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-01",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-11-01 00:00:00 +0500",
            "checkout_time": "2024-11-01 08:00:00 +0500"
        },
        {
            "id": 3900,
            "date": "2024-11-02",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:26 +0500",
            "updated_at": "2024-07-10 20:18:26 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-02",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-11-02 00:00:00 +0500",
            "checkout_time": "2024-11-02 08:00:00 +0500"
        },
        {
            "id": 3956,
            "date": "2024-11-02",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:20:50 +0500",
            "updated_at": "2024-07-10 20:20:50 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-02",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 76,
            "checkin_time": "2024-11-02 00:00:00 +0500",
            "checkout_time": "2024-11-02 08:00:00 +0500"
        },
        {
            "id": 4055,
            "date": "2024-11-02",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:24:47 +0500",
            "updated_at": "2024-07-10 20:24:47 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-02",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 69,
            "checkin_time": "2024-11-02 00:00:00 +0500",
            "checkout_time": "2024-11-02 08:00:00 +0500"
        },
        {
            "id": 3914,
            "date": "2024-11-03",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:18:37 +0500",
            "updated_at": "2024-07-10 20:18:37 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-03",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 69,
            "checkin_time": "2024-11-03 00:00:00 +0500",
            "checkout_time": "2024-11-03 07:00:00 +0500"
        },
        {
            "id": 3970,
            "date": "2024-11-03",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:46 +0500",
            "updated_at": "2024-07-10 20:21:46 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-03",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-11-03 00:00:00 +0500",
            "checkout_time": "2024-11-03 07:00:00 +0500"
        },
        {
            "id": 4069,
            "date": "2024-11-03",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:20 +0500",
            "updated_at": "2024-07-10 20:25:20 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-03",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-11-03 00:00:00 +0500",
            "checkout_time": "2024-11-03 07:00:00 +0500"
        },
        {
            "id": 3774,
            "date": "2024-11-04",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:13:59 +0500",
            "updated_at": "2024-07-10 20:13:59 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-04",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 70,
            "checkin_time": "2024-11-04 23:00:00 +0500",
            "checkout_time": "2024-11-04 07:00:00 +0500"
        },
        {
            "id": 3830,
            "date": "2024-11-04",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:16:04 +0500",
            "updated_at": "2024-07-10 20:16:04 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-04",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-11-04 23:00:00 +0500",
            "checkout_time": "2024-11-04 07:00:00 +0500"
        },
        {
            "id": 4083,
            "date": "2024-11-04",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:25:42 +0500",
            "updated_at": "2024-07-10 20:25:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-04",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-11-04 23:00:00 +0500",
            "checkout_time": "2024-11-04 07:00:00 +0500"
        },
        {
            "id": 3984,
            "date": "2024-11-04",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:21:56 +0500",
            "updated_at": "2024-07-10 20:21:56 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-04",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-11-04 23:00:00 +0500",
            "checkout_time": "2024-11-04 07:00:00 +0500"
        },
        {
            "id": 3788,
            "date": "2024-11-05",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:25 +0500",
            "updated_at": "2024-07-10 20:14:25 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-05",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-11-05 23:00:00 +0500",
            "checkout_time": "2024-11-05 07:00:00 +0500"
        },
        {
            "id": 3844,
            "date": "2024-11-05",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:00 +0500",
            "updated_at": "2024-07-10 20:17:00 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-05",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-11-05 23:00:00 +0500",
            "checkout_time": "2024-11-05 07:00:00 +0500"
        },
        {
            "id": 4097,
            "date": "2024-11-05",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:26:07 +0500",
            "updated_at": "2024-07-10 20:26:07 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-05",
            "sch_doctor_ids": [
                "82",
                "83",
                "84",
                "85",
                "57"
            ],
            "address_id": 76,
            "checkin_time": "2024-11-05 23:00:00 +0500",
            "checkout_time": "2024-11-05 07:00:00 +0500"
        },
        {
            "id": 3999,
            "date": "2024-11-05",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:30 +0500",
            "updated_at": "2024-07-10 20:22:30 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-05",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-11-05 23:00:00 +0500",
            "checkout_time": "2024-11-05 07:00:00 +0500"
        },
        {
            "id": 3802,
            "date": "2024-11-06",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:14:42 +0500",
            "updated_at": "2024-07-10 20:14:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-06",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-11-06 23:00:00 +0500",
            "checkout_time": "2024-11-06 07:00:00 +0500"
        },
        {
            "id": 3858,
            "date": "2024-11-06",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:17:11 +0500",
            "updated_at": "2024-07-10 20:17:11 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-06",
            "sch_doctor_ids": [
                "83"
            ],
            "address_id": 70,
            "checkin_time": "2024-11-06 23:00:00 +0500",
            "checkout_time": "2024-11-06 07:00:00 +0500"
        },
        {
            "id": 4013,
            "date": "2024-11-06",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:22:42 +0500",
            "updated_at": "2024-07-10 20:22:42 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-06",
            "sch_doctor_ids": [
                "84"
            ],
            "address_id": 69,
            "checkin_time": "2024-11-06 23:00:00 +0500",
            "checkout_time": "2024-11-06 07:00:00 +0500"
        },
        {
            "id": 3816,
            "date": "2024-11-07",
            "available": true,
            "break_time_from": null,
            "break_time_to": null,
            "created_at": "2024-07-10 20:15:08 +0500",
            "updated_at": "2024-07-10 20:15:08 +0500",
            "user_id": 46,
            "replicate": false,
            "with_flow": false,
            "date_range": "2024-11-07",
            "sch_doctor_ids": [
                "82"
            ],
            "address_id": 66,
            "checkin_time": "2024-11-07 23:00:00 +0500",
            "checkout_time": "2024-11-07 07:00:00 +0500"
        }
    ],
    "AppointmentTypeDoctors": [
        {
            "id": 406,
            "doctor_id": 82,
            "appointment_type_id": 126,
            "available": true,
            "created_at": "2024-07-10 20:51:27 +0500",
            "updated_at": "2024-07-10 20:51:27 +0500"
        },
        {
            "id": 407,
            "doctor_id": 83,
            "appointment_type_id": 126,
            "available": true,
            "created_at": "2024-07-10 20:51:27 +0500",
            "updated_at": "2024-07-10 20:51:27 +0500"
        },
        {
            "id": 408,
            "doctor_id": 84,
            "appointment_type_id": 126,
            "available": true,
            "created_at": "2024-07-10 20:51:27 +0500",
            "updated_at": "2024-07-10 20:51:27 +0500"
        },
        {
            "id": 409,
            "doctor_id": 85,
            "appointment_type_id": 126,
            "available": true,
            "created_at": "2024-07-10 20:51:27 +0500",
            "updated_at": "2024-07-10 20:51:27 +0500"
        },
        {
            "id": 410,
            "doctor_id": 57,
            "appointment_type_id": 126,
            "available": true,
            "created_at": "2024-07-10 20:51:27 +0500",
            "updated_at": "2024-07-10 20:51:27 +0500"
        },
        {
            "id": 411,
            "doctor_id": 82,
            "appointment_type_id": 127,
            "available": true,
            "created_at": "2024-07-10 20:51:50 +0500",
            "updated_at": "2024-07-10 20:51:50 +0500"
        },
        {
            "id": 412,
            "doctor_id": 83,
            "appointment_type_id": 127,
            "available": true,
            "created_at": "2024-07-10 20:51:50 +0500",
            "updated_at": "2024-07-10 20:51:50 +0500"
        },
        {
            "id": 413,
            "doctor_id": 84,
            "appointment_type_id": 127,
            "available": true,
            "created_at": "2024-07-10 20:51:50 +0500",
            "updated_at": "2024-07-10 20:51:50 +0500"
        },
        {
            "id": 414,
            "doctor_id": 85,
            "appointment_type_id": 127,
            "available": true,
            "created_at": "2024-07-10 20:51:50 +0500",
            "updated_at": "2024-07-10 20:51:50 +0500"
        },
        {
            "id": 415,
            "doctor_id": 57,
            "appointment_type_id": 127,
            "available": true,
            "created_at": "2024-07-10 20:51:50 +0500",
            "updated_at": "2024-07-10 20:51:50 +0500"
        },
        {
            "id": 416,
            "doctor_id": 82,
            "appointment_type_id": 128,
            "available": true,
            "created_at": "2024-07-10 20:55:11 +0500",
            "updated_at": "2024-07-10 20:55:11 +0500"
        },
        {
            "id": 417,
            "doctor_id": 83,
            "appointment_type_id": 128,
            "available": true,
            "created_at": "2024-07-10 20:55:11 +0500",
            "updated_at": "2024-07-10 20:55:11 +0500"
        },
        {
            "id": 418,
            "doctor_id": 84,
            "appointment_type_id": 128,
            "available": true,
            "created_at": "2024-07-10 20:55:11 +0500",
            "updated_at": "2024-07-10 20:55:11 +0500"
        },
        {
            "id": 419,
            "doctor_id": 85,
            "appointment_type_id": 128,
            "available": true,
            "created_at": "2024-07-10 20:55:11 +0500",
            "updated_at": "2024-07-10 20:55:11 +0500"
        },
        {
            "id": 420,
            "doctor_id": 57,
            "appointment_type_id": 128,
            "available": true,
            "created_at": "2024-07-10 20:55:11 +0500",
            "updated_at": "2024-07-10 20:55:11 +0500"
        },
        {
            "id": 421,
            "doctor_id": 82,
            "appointment_type_id": 129,
            "available": true,
            "created_at": "2024-07-10 20:55:37 +0500",
            "updated_at": "2024-07-10 20:55:37 +0500"
        },
        {
            "id": 422,
            "doctor_id": 83,
            "appointment_type_id": 129,
            "available": true,
            "created_at": "2024-07-10 20:55:37 +0500",
            "updated_at": "2024-07-10 20:55:37 +0500"
        },
        {
            "id": 423,
            "doctor_id": 84,
            "appointment_type_id": 129,
            "available": true,
            "created_at": "2024-07-10 20:55:37 +0500",
            "updated_at": "2024-07-10 20:55:37 +0500"
        },
        {
            "id": 424,
            "doctor_id": 85,
            "appointment_type_id": 129,
            "available": true,
            "created_at": "2024-07-10 20:55:37 +0500",
            "updated_at": "2024-07-10 20:55:37 +0500"
        },
        {
            "id": 425,
            "doctor_id": 57,
            "appointment_type_id": 129,
            "available": true,
            "created_at": "2024-07-10 20:55:37 +0500",
            "updated_at": "2024-07-10 20:55:37 +0500"
        },
        {
            "id": 426,
            "doctor_id": 82,
            "appointment_type_id": 130,
            "available": true,
            "created_at": "2024-07-10 20:56:23 +0500",
            "updated_at": "2024-07-10 20:56:23 +0500"
        },
        {
            "id": 427,
            "doctor_id": 83,
            "appointment_type_id": 130,
            "available": true,
            "created_at": "2024-07-10 20:56:23 +0500",
            "updated_at": "2024-07-10 20:56:23 +0500"
        },
        {
            "id": 428,
            "doctor_id": 84,
            "appointment_type_id": 130,
            "available": true,
            "created_at": "2024-07-10 20:56:23 +0500",
            "updated_at": "2024-07-10 20:56:23 +0500"
        },
        {
            "id": 429,
            "doctor_id": 85,
            "appointment_type_id": 130,
            "available": true,
            "created_at": "2024-07-10 20:56:23 +0500",
            "updated_at": "2024-07-10 20:56:23 +0500"
        },
        {
            "id": 430,
            "doctor_id": 57,
            "appointment_type_id": 130,
            "available": true,
            "created_at": "2024-07-10 20:56:23 +0500",
            "updated_at": "2024-07-10 20:56:23 +0500"
        },
        {
            "id": 431,
            "doctor_id": 82,
            "appointment_type_id": 131,
            "available": true,
            "created_at": "2024-07-10 20:56:43 +0500",
            "updated_at": "2024-07-10 20:56:43 +0500"
        },
        {
            "id": 432,
            "doctor_id": 83,
            "appointment_type_id": 131,
            "available": true,
            "created_at": "2024-07-10 20:56:43 +0500",
            "updated_at": "2024-07-10 20:56:43 +0500"
        },
        {
            "id": 433,
            "doctor_id": 84,
            "appointment_type_id": 131,
            "available": true,
            "created_at": "2024-07-10 20:56:43 +0500",
            "updated_at": "2024-07-10 20:56:43 +0500"
        },
        {
            "id": 434,
            "doctor_id": 85,
            "appointment_type_id": 131,
            "available": true,
            "created_at": "2024-07-10 20:56:43 +0500",
            "updated_at": "2024-07-10 20:56:43 +0500"
        },
        {
            "id": 435,
            "doctor_id": 57,
            "appointment_type_id": 131,
            "available": true,
            "created_at": "2024-07-10 20:56:43 +0500",
            "updated_at": "2024-07-10 20:56:43 +0500"
        },
        {
            "id": 436,
            "doctor_id": 82,
            "appointment_type_id": 132,
            "available": true,
            "created_at": "2024-07-10 20:57:01 +0500",
            "updated_at": "2024-07-10 20:57:01 +0500"
        },
        {
            "id": 437,
            "doctor_id": 83,
            "appointment_type_id": 132,
            "available": true,
            "created_at": "2024-07-10 20:57:01 +0500",
            "updated_at": "2024-07-10 20:57:01 +0500"
        },
        {
            "id": 438,
            "doctor_id": 84,
            "appointment_type_id": 132,
            "available": true,
            "created_at": "2024-07-10 20:57:01 +0500",
            "updated_at": "2024-07-10 20:57:01 +0500"
        },
        {
            "id": 439,
            "doctor_id": 85,
            "appointment_type_id": 132,
            "available": true,
            "created_at": "2024-07-10 20:57:01 +0500",
            "updated_at": "2024-07-10 20:57:01 +0500"
        },
        {
            "id": 440,
            "doctor_id": 57,
            "appointment_type_id": 132,
            "available": true,
            "created_at": "2024-07-10 20:57:01 +0500",
            "updated_at": "2024-07-10 20:57:01 +0500"
        },
        {
            "id": 441,
            "doctor_id": 82,
            "appointment_type_id": 133,
            "available": true,
            "created_at": "2024-07-10 20:57:26 +0500",
            "updated_at": "2024-07-10 20:57:26 +0500"
        },
        {
            "id": 442,
            "doctor_id": 83,
            "appointment_type_id": 133,
            "available": true,
            "created_at": "2024-07-10 20:57:26 +0500",
            "updated_at": "2024-07-10 20:57:26 +0500"
        },
        {
            "id": 443,
            "doctor_id": 84,
            "appointment_type_id": 133,
            "available": true,
            "created_at": "2024-07-10 20:57:26 +0500",
            "updated_at": "2024-07-10 20:57:26 +0500"
        },
        {
            "id": 444,
            "doctor_id": 85,
            "appointment_type_id": 133,
            "available": true,
            "created_at": "2024-07-10 20:57:26 +0500",
            "updated_at": "2024-07-10 20:57:26 +0500"
        },
        {
            "id": 445,
            "doctor_id": 57,
            "appointment_type_id": 133,
            "available": true,
            "created_at": "2024-07-10 20:57:26 +0500",
            "updated_at": "2024-07-10 20:57:26 +0500"
        },
        {
            "id": 446,
            "doctor_id": 82,
            "appointment_type_id": 134,
            "available": true,
            "created_at": "2024-07-10 20:57:45 +0500",
            "updated_at": "2024-07-10 20:57:45 +0500"
        },
        {
            "id": 447,
            "doctor_id": 83,
            "appointment_type_id": 134,
            "available": true,
            "created_at": "2024-07-10 20:57:45 +0500",
            "updated_at": "2024-07-10 20:57:45 +0500"
        },
        {
            "id": 448,
            "doctor_id": 84,
            "appointment_type_id": 134,
            "available": true,
            "created_at": "2024-07-10 20:57:45 +0500",
            "updated_at": "2024-07-10 20:57:45 +0500"
        },
        {
            "id": 449,
            "doctor_id": 85,
            "appointment_type_id": 134,
            "available": true,
            "created_at": "2024-07-10 20:57:45 +0500",
            "updated_at": "2024-07-10 20:57:45 +0500"
        },
        {
            "id": 450,
            "doctor_id": 57,
            "appointment_type_id": 134,
            "available": true,
            "created_at": "2024-07-10 20:57:45 +0500",
            "updated_at": "2024-07-10 20:57:45 +0500"
        },
        {
            "id": 451,
            "doctor_id": 82,
            "appointment_type_id": 135,
            "available": true,
            "created_at": "2024-07-10 20:58:02 +0500",
            "updated_at": "2024-07-10 20:58:02 +0500"
        },
        {
            "id": 452,
            "doctor_id": 83,
            "appointment_type_id": 135,
            "available": true,
            "created_at": "2024-07-10 20:58:02 +0500",
            "updated_at": "2024-07-10 20:58:02 +0500"
        },
        {
            "id": 453,
            "doctor_id": 84,
            "appointment_type_id": 135,
            "available": true,
            "created_at": "2024-07-10 20:58:02 +0500",
            "updated_at": "2024-07-10 20:58:02 +0500"
        },
        {
            "id": 454,
            "doctor_id": 85,
            "appointment_type_id": 135,
            "available": true,
            "created_at": "2024-07-10 20:58:02 +0500",
            "updated_at": "2024-07-10 20:58:02 +0500"
        },
        {
            "id": 455,
            "doctor_id": 57,
            "appointment_type_id": 135,
            "available": true,
            "created_at": "2024-07-10 20:58:02 +0500",
            "updated_at": "2024-07-10 20:58:02 +0500"
        },
        {
            "id": 401,
            "doctor_id": 82,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-07-10 20:50:41 +0500",
            "updated_at": "2024-07-10 20:50:41 +0500"
        },
        {
            "id": 402,
            "doctor_id": 83,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-07-10 20:50:50 +0500",
            "updated_at": "2024-07-10 20:50:50 +0500"
        },
        {
            "id": 403,
            "doctor_id": 84,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-07-10 20:50:50 +0500",
            "updated_at": "2024-07-10 20:50:50 +0500"
        },
        {
            "id": 404,
            "doctor_id": 85,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-07-10 20:50:50 +0500",
            "updated_at": "2024-07-10 20:50:50 +0500"
        },
        {
            "id": 405,
            "doctor_id": 57,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-07-10 20:50:50 +0500",
            "updated_at": "2024-07-10 20:50:50 +0500"
        },
        {
            "id": 525,
            "doctor_id": 65,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 526,
            "doctor_id": 66,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 527,
            "doctor_id": 71,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 528,
            "doctor_id": 81,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 529,
            "doctor_id": 184,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 530,
            "doctor_id": 185,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 531,
            "doctor_id": 186,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 532,
            "doctor_id": 181,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 533,
            "doctor_id": 182,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 534,
            "doctor_id": 183,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 21:59:05 +0500",
            "updated_at": "2024-08-21 21:59:05 +0500"
        },
        {
            "id": 535,
            "doctor_id": 187,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 536,
            "doctor_id": 188,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 537,
            "doctor_id": 189,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 538,
            "doctor_id": 190,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 539,
            "doctor_id": 191,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 540,
            "doctor_id": 192,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 541,
            "doctor_id": 193,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 542,
            "doctor_id": 194,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 543,
            "doctor_id": 195,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 544,
            "doctor_id": 196,
            "appointment_type_id": 125,
            "available": true,
            "created_at": "2024-08-21 22:03:34 +0500",
            "updated_at": "2024-08-21 22:03:34 +0500"
        },
        {
            "id": 122,
            "doctor_id": 57,
            "appointment_type_id": 80,
            "available": true,
            "created_at": "2023-09-29 22:31:26 +0500",
            "updated_at": "2023-09-29 22:31:26 +0500"
        },
        {
            "id": 393,
            "doctor_id": 65,
            "appointment_type_id": 80,
            "available": true,
            "created_at": "2024-07-09 23:35:54 +0500",
            "updated_at": "2024-07-09 23:35:54 +0500"
        },
        {
            "id": 394,
            "doctor_id": 66,
            "appointment_type_id": 80,
            "available": true,
            "created_at": "2024-07-09 23:35:54 +0500",
            "updated_at": "2024-07-09 23:35:54 +0500"
        },
        {
            "id": 386,
            "doctor_id": 57,
            "appointment_type_id": 112,
            "available": true,
            "created_at": "2024-02-16 01:07:50 +0500",
            "updated_at": "2024-02-16 01:07:50 +0500"
        },
        {
            "id": 150,
            "doctor_id": 65,
            "appointment_type_id": 113,
            "available": true,
            "created_at": "2024-01-03 20:25:24 +0500",
            "updated_at": "2024-01-03 20:25:24 +0500"
        }
    ],
    "FormFields": [
        {
            "id": 11,
            "label": "Insurance ID",
            "is_required": false,
            "placeholder": "Insurance ID",
            "error_message": null,
            "is_visible": true,
            "hide_label": false,
            "value": "",
            "options": [
                {
                    "label": "short_text",
                    "value": "long text",
                    "is_selected": true
                }
            ],
            "sort": 3,
            "applicable_to_form": "appointment/patient_info",
            "user_id": 57,
            "field_type_id": 1,
            "user_type_id": 1,
            "html_attributes": {
                "id": "",
                "name": "insurance_id",
                "class": "",
                "style": "",
                "data-attributes": {}
            },
            "display_format": {
                "type": "row",
                "columns": "number"
            }
        },
        {
            "id": 13,
            "label": "Select Patient",
            "is_required": false,
            "placeholder": null,
            "error_message": null,
            "is_visible": true,
            "hide_label": false,
            "value": "",
            "options": [
                {
                    "label": "New Patient",
                    "value": "New Patient",
                    "is_selected": true
                },
                {
                    "label": "Existing Patient",
                    "value": "Existing Patient",
                    "is_selected": false
                }
            ],
            "sort": 4,
            "applicable_to_form": "appointment/patient_info",
            "user_id": 57,
            "field_type_id": 8,
            "user_type_id": 1,
            "html_attributes": {
                "id": "",
                "name": "select_patient",
                "class": "",
                "style": "",
                "data-attributes": {}
            },
            "display_format": {
                "type": "row",
                "columns": "number"
            }
        },
        {
            "id": 2,
            "label": "Insurance Name",
            "is_required": true,
            "placeholder": "Your Insurance Name",
            "error_message": "Insurance name  is required",
            "is_visible": true,
            "hide_label": false,
            "value": "",
            "options": [
                {
                    "label": "short_text",
                    "value": "long text",
                    "is_selected": true
                }
            ],
            "sort": 2,
            "applicable_to_form": "appointment/patient_info",
            "user_id": 57,
            "field_type_id": 1,
            "user_type_id": 1,
            "html_attributes": {
                "id": "",
                "name": "insurance_name",
                "class": "",
                "style": "",
                "data-attributes": {}
            },
            "display_format": {
                "type": "row",
                "columns": "number"
            }
        },
        {
            "id": 1,
            "label": "Birth Date",
            "is_required": true,
            "placeholder": "Birth Date MM/DD/YYYY",
            "error_message": "Date of birth is required",
            "is_visible": true,
            "hide_label": false,
            "value": "",
            "options": [
                {
                    "label": "date",
                    "value": "",
                    "is_selected": true
                }
            ],
            "sort": 1,
            "applicable_to_form": "appointment/patient_info",
            "user_id": 57,
            "field_type_id": 4,
            "user_type_id": 1,
            "html_attributes": {
                "id": "",
                "name": "date_of_birth",
                "class": "",
                "style": "",
                "data-attributes": {}
            },
            "display_format": {
                "type": "row",
                "columns": "number"
            }
        }
    ],
    "FilterdSchedules": {
        "doctor_57": {
            "address_70": [
                {
                    "id": 4108,
                    "date": "2024-09-21",
                    "date_range": "2024-09-21",
                    "sch_doctor_ids": [
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-21 09:00:00 +0500",
                    "checkout_time": "2024-09-21 17:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4121,
                    "date": "2024-09-21",
                    "date_range": "2024-09-21",
                    "sch_doctor_ids": [
                        "",
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-21 10:00:00 +0500",
                    "checkout_time": "2024-09-21 11:30:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3620,
                    "date": "2024-09-23",
                    "date_range": "2024-09-23",
                    "sch_doctor_ids": [
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-23 09:00:00 +0500",
                    "checkout_time": "2024-09-23 17:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4109,
                    "date": "2024-09-28",
                    "date_range": "2024-09-28",
                    "sch_doctor_ids": [
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-28 09:00:00 +0500",
                    "checkout_time": "2024-09-28 17:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4122,
                    "date": "2024-09-28",
                    "date_range": "2024-09-28",
                    "sch_doctor_ids": [
                        "",
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-28 10:00:00 +0500",
                    "checkout_time": "2024-09-28 11:30:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3621,
                    "date": "2024-09-30",
                    "date_range": "2024-09-30",
                    "sch_doctor_ids": [
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-30 09:00:00 +0500",
                    "checkout_time": "2024-09-30 17:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4110,
                    "date": "2024-10-05",
                    "date_range": "2024-10-05",
                    "sch_doctor_ids": [
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-05 09:00:00 +0500",
                    "checkout_time": "2024-10-05 17:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4123,
                    "date": "2024-10-05",
                    "date_range": "2024-10-05",
                    "sch_doctor_ids": [
                        "",
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-05 10:00:00 +0500",
                    "checkout_time": "2024-10-05 11:30:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4111,
                    "date": "2024-10-12",
                    "date_range": "2024-10-12",
                    "sch_doctor_ids": [
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-12 09:00:00 +0500",
                    "checkout_time": "2024-10-12 17:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4124,
                    "date": "2024-10-12",
                    "date_range": "2024-10-12",
                    "sch_doctor_ids": [
                        "",
                        "57"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-12 10:00:00 +0500",
                    "checkout_time": "2024-10-12 11:30:00 +0500",
                    "appointments": []
                }
            ],
            "address_69": [
                {
                    "id": 4035,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4049,
                    "date": "2024-09-21",
                    "date_range": "2024-09-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-21 00:00:00 +0500",
                    "checkout_time": "2024-09-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4022,
                    "date": "2024-09-26",
                    "date_range": "2024-09-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-26 00:00:00 +0500",
                    "checkout_time": "2024-09-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4036,
                    "date": "2024-09-27",
                    "date_range": "2024-09-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-27 00:00:00 +0500",
                    "checkout_time": "2024-09-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4050,
                    "date": "2024-09-28",
                    "date_range": "2024-09-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-28 00:00:00 +0500",
                    "checkout_time": "2024-09-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4023,
                    "date": "2024-10-03",
                    "date_range": "2024-10-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-03 00:00:00 +0500",
                    "checkout_time": "2024-10-03 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4037,
                    "date": "2024-10-04",
                    "date_range": "2024-10-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-04 00:00:00 +0500",
                    "checkout_time": "2024-10-04 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4051,
                    "date": "2024-10-05",
                    "date_range": "2024-10-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-05 00:00:00 +0500",
                    "checkout_time": "2024-10-05 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4024,
                    "date": "2024-10-10",
                    "date_range": "2024-10-10",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-10 00:00:00 +0500",
                    "checkout_time": "2024-10-10 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4038,
                    "date": "2024-10-11",
                    "date_range": "2024-10-11",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-11 00:00:00 +0500",
                    "checkout_time": "2024-10-11 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4052,
                    "date": "2024-10-12",
                    "date_range": "2024-10-12",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-12 00:00:00 +0500",
                    "checkout_time": "2024-10-12 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4025,
                    "date": "2024-10-17",
                    "date_range": "2024-10-17",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-17 00:00:00 +0500",
                    "checkout_time": "2024-10-17 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4039,
                    "date": "2024-10-18",
                    "date_range": "2024-10-18",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-18 00:00:00 +0500",
                    "checkout_time": "2024-10-18 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4053,
                    "date": "2024-10-19",
                    "date_range": "2024-10-19",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-19 00:00:00 +0500",
                    "checkout_time": "2024-10-19 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4026,
                    "date": "2024-10-24",
                    "date_range": "2024-10-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-24 00:00:00 +0500",
                    "checkout_time": "2024-10-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4040,
                    "date": "2024-10-25",
                    "date_range": "2024-10-25",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-25 00:00:00 +0500",
                    "checkout_time": "2024-10-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4054,
                    "date": "2024-10-26",
                    "date_range": "2024-10-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-26 00:00:00 +0500",
                    "checkout_time": "2024-10-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4027,
                    "date": "2024-10-31",
                    "date_range": "2024-10-31",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-31 00:00:00 +0500",
                    "checkout_time": "2024-10-31 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4041,
                    "date": "2024-11-01",
                    "date_range": "2024-11-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-01 00:00:00 +0500",
                    "checkout_time": "2024-11-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4055,
                    "date": "2024-11-02",
                    "date_range": "2024-11-02",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-02 00:00:00 +0500",
                    "checkout_time": "2024-11-02 08:00:00 +0500",
                    "appointments": []
                }
            ],
            "address_76": [
                {
                    "id": 8429,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4063,
                    "date": "2024-09-22",
                    "date_range": "2024-09-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-22 00:00:00 +0500",
                    "checkout_time": "2024-09-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4077,
                    "date": "2024-09-23",
                    "date_range": "2024-09-23",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-23 00:00:00 +0500",
                    "checkout_time": "2024-09-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4091,
                    "date": "2024-09-24",
                    "date_range": "2024-09-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-24 00:00:00 +0500",
                    "checkout_time": "2024-09-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4064,
                    "date": "2024-09-29",
                    "date_range": "2024-09-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-29 00:00:00 +0500",
                    "checkout_time": "2024-09-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4078,
                    "date": "2024-09-30",
                    "date_range": "2024-09-30",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-30 00:00:00 +0500",
                    "checkout_time": "2024-09-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4092,
                    "date": "2024-10-01",
                    "date_range": "2024-10-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-01 00:00:00 +0500",
                    "checkout_time": "2024-10-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4065,
                    "date": "2024-10-06",
                    "date_range": "2024-10-06",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-06 00:00:00 +0500",
                    "checkout_time": "2024-10-06 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4079,
                    "date": "2024-10-07",
                    "date_range": "2024-10-07",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-07 00:00:00 +0500",
                    "checkout_time": "2024-10-07 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4093,
                    "date": "2024-10-08",
                    "date_range": "2024-10-08",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-08 00:00:00 +0500",
                    "checkout_time": "2024-10-08 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4066,
                    "date": "2024-10-13",
                    "date_range": "2024-10-13",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-13 00:00:00 +0500",
                    "checkout_time": "2024-10-13 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4080,
                    "date": "2024-10-14",
                    "date_range": "2024-10-14",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-14 00:00:00 +0500",
                    "checkout_time": "2024-10-14 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4094,
                    "date": "2024-10-15",
                    "date_range": "2024-10-15",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-15 00:00:00 +0500",
                    "checkout_time": "2024-10-15 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4067,
                    "date": "2024-10-20",
                    "date_range": "2024-10-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-20 00:00:00 +0500",
                    "checkout_time": "2024-10-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4081,
                    "date": "2024-10-21",
                    "date_range": "2024-10-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-21 00:00:00 +0500",
                    "checkout_time": "2024-10-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4095,
                    "date": "2024-10-22",
                    "date_range": "2024-10-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-22 00:00:00 +0500",
                    "checkout_time": "2024-10-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4068,
                    "date": "2024-10-27",
                    "date_range": "2024-10-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-27 00:00:00 +0500",
                    "checkout_time": "2024-10-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4082,
                    "date": "2024-10-28",
                    "date_range": "2024-10-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-28 00:00:00 +0500",
                    "checkout_time": "2024-10-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4096,
                    "date": "2024-10-29",
                    "date_range": "2024-10-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-29 00:00:00 +0500",
                    "checkout_time": "2024-10-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4069,
                    "date": "2024-11-03",
                    "date_range": "2024-11-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-03 00:00:00 +0500",
                    "checkout_time": "2024-11-03 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4083,
                    "date": "2024-11-04",
                    "date_range": "2024-11-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-04 23:00:00 +0500",
                    "checkout_time": "2024-11-04 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4097,
                    "date": "2024-11-05",
                    "date_range": "2024-11-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-05 23:00:00 +0500",
                    "checkout_time": "2024-11-05 07:00:00 +0500",
                    "appointments": []
                }
            ]
        },
        "doctor_65": {},
        "doctor_66": {},
        "doctor_71": {},
        "doctor_81": {},
        "doctor_82": {
            "address_70": [
                {
                    "id": 3754,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3768,
                    "date": "2024-09-23",
                    "date_range": "2024-09-23",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-23 00:00:00 +0500",
                    "checkout_time": "2024-09-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3741,
                    "date": "2024-09-26",
                    "date_range": "2024-09-26",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-26 00:00:00 +0500",
                    "checkout_time": "2024-09-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3755,
                    "date": "2024-09-27",
                    "date_range": "2024-09-27",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-27 00:00:00 +0500",
                    "checkout_time": "2024-09-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3769,
                    "date": "2024-09-30",
                    "date_range": "2024-09-30",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-30 00:00:00 +0500",
                    "checkout_time": "2024-09-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3742,
                    "date": "2024-10-03",
                    "date_range": "2024-10-03",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-03 00:00:00 +0500",
                    "checkout_time": "2024-10-03 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3756,
                    "date": "2024-10-04",
                    "date_range": "2024-10-04",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-04 00:00:00 +0500",
                    "checkout_time": "2024-10-04 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3770,
                    "date": "2024-10-07",
                    "date_range": "2024-10-07",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-07 00:00:00 +0500",
                    "checkout_time": "2024-10-07 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3743,
                    "date": "2024-10-10",
                    "date_range": "2024-10-10",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-10 00:00:00 +0500",
                    "checkout_time": "2024-10-10 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3757,
                    "date": "2024-10-11",
                    "date_range": "2024-10-11",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-11 00:00:00 +0500",
                    "checkout_time": "2024-10-11 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3771,
                    "date": "2024-10-14",
                    "date_range": "2024-10-14",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-14 00:00:00 +0500",
                    "checkout_time": "2024-10-14 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3744,
                    "date": "2024-10-17",
                    "date_range": "2024-10-17",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-17 00:00:00 +0500",
                    "checkout_time": "2024-10-17 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3758,
                    "date": "2024-10-18",
                    "date_range": "2024-10-18",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-18 00:00:00 +0500",
                    "checkout_time": "2024-10-18 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3772,
                    "date": "2024-10-21",
                    "date_range": "2024-10-21",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-21 00:00:00 +0500",
                    "checkout_time": "2024-10-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3745,
                    "date": "2024-10-24",
                    "date_range": "2024-10-24",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-24 00:00:00 +0500",
                    "checkout_time": "2024-10-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3759,
                    "date": "2024-10-25",
                    "date_range": "2024-10-25",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-25 00:00:00 +0500",
                    "checkout_time": "2024-10-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3773,
                    "date": "2024-10-28",
                    "date_range": "2024-10-28",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-28 00:00:00 +0500",
                    "checkout_time": "2024-10-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3746,
                    "date": "2024-10-31",
                    "date_range": "2024-10-31",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-31 00:00:00 +0500",
                    "checkout_time": "2024-10-31 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3760,
                    "date": "2024-11-01",
                    "date_range": "2024-11-01",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-11-01 00:00:00 +0500",
                    "checkout_time": "2024-11-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3774,
                    "date": "2024-11-04",
                    "date_range": "2024-11-04",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-11-04 23:00:00 +0500",
                    "checkout_time": "2024-11-04 07:00:00 +0500",
                    "appointments": []
                }
            ],
            "address_66": [
                {
                    "id": 3782,
                    "date": "2024-09-24",
                    "date_range": "2024-09-24",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-09-24 00:00:00 +0500",
                    "checkout_time": "2024-09-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3796,
                    "date": "2024-09-25",
                    "date_range": "2024-09-25",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-09-25 00:00:00 +0500",
                    "checkout_time": "2024-09-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3810,
                    "date": "2024-09-26",
                    "date_range": "2024-09-26",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-09-26 00:00:00 +0500",
                    "checkout_time": "2024-09-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3783,
                    "date": "2024-10-01",
                    "date_range": "2024-10-01",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-01 00:00:00 +0500",
                    "checkout_time": "2024-10-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3797,
                    "date": "2024-10-02",
                    "date_range": "2024-10-02",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-02 00:00:00 +0500",
                    "checkout_time": "2024-10-02 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3811,
                    "date": "2024-10-03",
                    "date_range": "2024-10-03",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-03 00:00:00 +0500",
                    "checkout_time": "2024-10-03 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3784,
                    "date": "2024-10-08",
                    "date_range": "2024-10-08",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-08 00:00:00 +0500",
                    "checkout_time": "2024-10-08 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3798,
                    "date": "2024-10-09",
                    "date_range": "2024-10-09",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-09 00:00:00 +0500",
                    "checkout_time": "2024-10-09 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3812,
                    "date": "2024-10-10",
                    "date_range": "2024-10-10",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-10 00:00:00 +0500",
                    "checkout_time": "2024-10-10 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3785,
                    "date": "2024-10-15",
                    "date_range": "2024-10-15",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-15 00:00:00 +0500",
                    "checkout_time": "2024-10-15 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3799,
                    "date": "2024-10-16",
                    "date_range": "2024-10-16",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-16 00:00:00 +0500",
                    "checkout_time": "2024-10-16 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3813,
                    "date": "2024-10-17",
                    "date_range": "2024-10-17",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-17 00:00:00 +0500",
                    "checkout_time": "2024-10-17 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3786,
                    "date": "2024-10-22",
                    "date_range": "2024-10-22",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-22 00:00:00 +0500",
                    "checkout_time": "2024-10-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3800,
                    "date": "2024-10-23",
                    "date_range": "2024-10-23",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-23 00:00:00 +0500",
                    "checkout_time": "2024-10-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3814,
                    "date": "2024-10-24",
                    "date_range": "2024-10-24",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-24 00:00:00 +0500",
                    "checkout_time": "2024-10-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3787,
                    "date": "2024-10-29",
                    "date_range": "2024-10-29",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-29 00:00:00 +0500",
                    "checkout_time": "2024-10-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3801,
                    "date": "2024-10-30",
                    "date_range": "2024-10-30",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-30 00:00:00 +0500",
                    "checkout_time": "2024-10-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3815,
                    "date": "2024-10-31",
                    "date_range": "2024-10-31",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-10-31 00:00:00 +0500",
                    "checkout_time": "2024-10-31 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3788,
                    "date": "2024-11-05",
                    "date_range": "2024-11-05",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-11-05 23:00:00 +0500",
                    "checkout_time": "2024-11-05 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3802,
                    "date": "2024-11-06",
                    "date_range": "2024-11-06",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-11-06 23:00:00 +0500",
                    "checkout_time": "2024-11-06 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3816,
                    "date": "2024-11-07",
                    "date_range": "2024-11-07",
                    "sch_doctor_ids": [
                        "82"
                    ],
                    "address_id": 66,
                    "checkin_time": "2024-11-07 23:00:00 +0500",
                    "checkout_time": "2024-11-07 07:00:00 +0500",
                    "appointments": []
                }
            ],
            "address_69": [
                {
                    "id": 4035,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4049,
                    "date": "2024-09-21",
                    "date_range": "2024-09-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-21 00:00:00 +0500",
                    "checkout_time": "2024-09-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4022,
                    "date": "2024-09-26",
                    "date_range": "2024-09-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-26 00:00:00 +0500",
                    "checkout_time": "2024-09-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4036,
                    "date": "2024-09-27",
                    "date_range": "2024-09-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-27 00:00:00 +0500",
                    "checkout_time": "2024-09-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4050,
                    "date": "2024-09-28",
                    "date_range": "2024-09-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-28 00:00:00 +0500",
                    "checkout_time": "2024-09-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4023,
                    "date": "2024-10-03",
                    "date_range": "2024-10-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-03 00:00:00 +0500",
                    "checkout_time": "2024-10-03 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4037,
                    "date": "2024-10-04",
                    "date_range": "2024-10-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-04 00:00:00 +0500",
                    "checkout_time": "2024-10-04 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4051,
                    "date": "2024-10-05",
                    "date_range": "2024-10-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-05 00:00:00 +0500",
                    "checkout_time": "2024-10-05 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4024,
                    "date": "2024-10-10",
                    "date_range": "2024-10-10",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-10 00:00:00 +0500",
                    "checkout_time": "2024-10-10 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4038,
                    "date": "2024-10-11",
                    "date_range": "2024-10-11",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-11 00:00:00 +0500",
                    "checkout_time": "2024-10-11 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4052,
                    "date": "2024-10-12",
                    "date_range": "2024-10-12",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-12 00:00:00 +0500",
                    "checkout_time": "2024-10-12 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4025,
                    "date": "2024-10-17",
                    "date_range": "2024-10-17",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-17 00:00:00 +0500",
                    "checkout_time": "2024-10-17 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4039,
                    "date": "2024-10-18",
                    "date_range": "2024-10-18",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-18 00:00:00 +0500",
                    "checkout_time": "2024-10-18 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4053,
                    "date": "2024-10-19",
                    "date_range": "2024-10-19",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-19 00:00:00 +0500",
                    "checkout_time": "2024-10-19 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4026,
                    "date": "2024-10-24",
                    "date_range": "2024-10-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-24 00:00:00 +0500",
                    "checkout_time": "2024-10-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4040,
                    "date": "2024-10-25",
                    "date_range": "2024-10-25",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-25 00:00:00 +0500",
                    "checkout_time": "2024-10-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4054,
                    "date": "2024-10-26",
                    "date_range": "2024-10-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-26 00:00:00 +0500",
                    "checkout_time": "2024-10-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4027,
                    "date": "2024-10-31",
                    "date_range": "2024-10-31",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-31 00:00:00 +0500",
                    "checkout_time": "2024-10-31 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4041,
                    "date": "2024-11-01",
                    "date_range": "2024-11-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-01 00:00:00 +0500",
                    "checkout_time": "2024-11-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4055,
                    "date": "2024-11-02",
                    "date_range": "2024-11-02",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-02 00:00:00 +0500",
                    "checkout_time": "2024-11-02 08:00:00 +0500",
                    "appointments": []
                }
            ],
            "address_76": [
                {
                    "id": 8429,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4063,
                    "date": "2024-09-22",
                    "date_range": "2024-09-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-22 00:00:00 +0500",
                    "checkout_time": "2024-09-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4077,
                    "date": "2024-09-23",
                    "date_range": "2024-09-23",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-23 00:00:00 +0500",
                    "checkout_time": "2024-09-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4091,
                    "date": "2024-09-24",
                    "date_range": "2024-09-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-24 00:00:00 +0500",
                    "checkout_time": "2024-09-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4064,
                    "date": "2024-09-29",
                    "date_range": "2024-09-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-29 00:00:00 +0500",
                    "checkout_time": "2024-09-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4078,
                    "date": "2024-09-30",
                    "date_range": "2024-09-30",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-30 00:00:00 +0500",
                    "checkout_time": "2024-09-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4092,
                    "date": "2024-10-01",
                    "date_range": "2024-10-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-01 00:00:00 +0500",
                    "checkout_time": "2024-10-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4065,
                    "date": "2024-10-06",
                    "date_range": "2024-10-06",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-06 00:00:00 +0500",
                    "checkout_time": "2024-10-06 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4079,
                    "date": "2024-10-07",
                    "date_range": "2024-10-07",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-07 00:00:00 +0500",
                    "checkout_time": "2024-10-07 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4093,
                    "date": "2024-10-08",
                    "date_range": "2024-10-08",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-08 00:00:00 +0500",
                    "checkout_time": "2024-10-08 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4066,
                    "date": "2024-10-13",
                    "date_range": "2024-10-13",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-13 00:00:00 +0500",
                    "checkout_time": "2024-10-13 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4080,
                    "date": "2024-10-14",
                    "date_range": "2024-10-14",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-14 00:00:00 +0500",
                    "checkout_time": "2024-10-14 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4094,
                    "date": "2024-10-15",
                    "date_range": "2024-10-15",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-15 00:00:00 +0500",
                    "checkout_time": "2024-10-15 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4067,
                    "date": "2024-10-20",
                    "date_range": "2024-10-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-20 00:00:00 +0500",
                    "checkout_time": "2024-10-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4081,
                    "date": "2024-10-21",
                    "date_range": "2024-10-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-21 00:00:00 +0500",
                    "checkout_time": "2024-10-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4095,
                    "date": "2024-10-22",
                    "date_range": "2024-10-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-22 00:00:00 +0500",
                    "checkout_time": "2024-10-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4068,
                    "date": "2024-10-27",
                    "date_range": "2024-10-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-27 00:00:00 +0500",
                    "checkout_time": "2024-10-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4082,
                    "date": "2024-10-28",
                    "date_range": "2024-10-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-28 00:00:00 +0500",
                    "checkout_time": "2024-10-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4096,
                    "date": "2024-10-29",
                    "date_range": "2024-10-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-29 00:00:00 +0500",
                    "checkout_time": "2024-10-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4069,
                    "date": "2024-11-03",
                    "date_range": "2024-11-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-03 00:00:00 +0500",
                    "checkout_time": "2024-11-03 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4083,
                    "date": "2024-11-04",
                    "date_range": "2024-11-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-04 23:00:00 +0500",
                    "checkout_time": "2024-11-04 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4097,
                    "date": "2024-11-05",
                    "date_range": "2024-11-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-05 23:00:00 +0500",
                    "checkout_time": "2024-11-05 07:00:00 +0500",
                    "appointments": []
                }
            ]
        },
        "doctor_83": {
            "address_70": [
                {
                    "id": 3824,
                    "date": "2024-09-23",
                    "date_range": "2024-09-23",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-23 00:00:00 +0500",
                    "checkout_time": "2024-09-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3838,
                    "date": "2024-09-24",
                    "date_range": "2024-09-24",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-24 00:00:00 +0500",
                    "checkout_time": "2024-09-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3852,
                    "date": "2024-09-25",
                    "date_range": "2024-09-25",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-25 00:00:00 +0500",
                    "checkout_time": "2024-09-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3825,
                    "date": "2024-09-30",
                    "date_range": "2024-09-30",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-09-30 00:00:00 +0500",
                    "checkout_time": "2024-09-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3839,
                    "date": "2024-10-01",
                    "date_range": "2024-10-01",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-01 00:00:00 +0500",
                    "checkout_time": "2024-10-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3853,
                    "date": "2024-10-02",
                    "date_range": "2024-10-02",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-02 00:00:00 +0500",
                    "checkout_time": "2024-10-02 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3826,
                    "date": "2024-10-07",
                    "date_range": "2024-10-07",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-07 00:00:00 +0500",
                    "checkout_time": "2024-10-07 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3840,
                    "date": "2024-10-08",
                    "date_range": "2024-10-08",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-08 00:00:00 +0500",
                    "checkout_time": "2024-10-08 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3854,
                    "date": "2024-10-09",
                    "date_range": "2024-10-09",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-09 00:00:00 +0500",
                    "checkout_time": "2024-10-09 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3827,
                    "date": "2024-10-14",
                    "date_range": "2024-10-14",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-14 00:00:00 +0500",
                    "checkout_time": "2024-10-14 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3841,
                    "date": "2024-10-15",
                    "date_range": "2024-10-15",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-15 00:00:00 +0500",
                    "checkout_time": "2024-10-15 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3855,
                    "date": "2024-10-16",
                    "date_range": "2024-10-16",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-16 00:00:00 +0500",
                    "checkout_time": "2024-10-16 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3828,
                    "date": "2024-10-21",
                    "date_range": "2024-10-21",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-21 00:00:00 +0500",
                    "checkout_time": "2024-10-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3842,
                    "date": "2024-10-22",
                    "date_range": "2024-10-22",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-22 00:00:00 +0500",
                    "checkout_time": "2024-10-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3856,
                    "date": "2024-10-23",
                    "date_range": "2024-10-23",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-23 00:00:00 +0500",
                    "checkout_time": "2024-10-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3829,
                    "date": "2024-10-28",
                    "date_range": "2024-10-28",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-28 00:00:00 +0500",
                    "checkout_time": "2024-10-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3843,
                    "date": "2024-10-29",
                    "date_range": "2024-10-29",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-29 00:00:00 +0500",
                    "checkout_time": "2024-10-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3857,
                    "date": "2024-10-30",
                    "date_range": "2024-10-30",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-10-30 00:00:00 +0500",
                    "checkout_time": "2024-10-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3830,
                    "date": "2024-11-04",
                    "date_range": "2024-11-04",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-11-04 23:00:00 +0500",
                    "checkout_time": "2024-11-04 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3844,
                    "date": "2024-11-05",
                    "date_range": "2024-11-05",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-11-05 23:00:00 +0500",
                    "checkout_time": "2024-11-05 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3858,
                    "date": "2024-11-06",
                    "date_range": "2024-11-06",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 70,
                    "checkin_time": "2024-11-06 23:00:00 +0500",
                    "checkout_time": "2024-11-06 07:00:00 +0500",
                    "appointments": []
                }
            ],
            "address_69": [
                {
                    "id": 4035,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3880,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3894,
                    "date": "2024-09-21",
                    "date_range": "2024-09-21",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-21 00:00:00 +0500",
                    "checkout_time": "2024-09-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4049,
                    "date": "2024-09-21",
                    "date_range": "2024-09-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-21 00:00:00 +0500",
                    "checkout_time": "2024-09-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3908,
                    "date": "2024-09-22",
                    "date_range": "2024-09-22",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-22 00:00:00 +0500",
                    "checkout_time": "2024-09-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3867,
                    "date": "2024-09-26",
                    "date_range": "2024-09-26",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-26 00:00:00 +0500",
                    "checkout_time": "2024-09-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4022,
                    "date": "2024-09-26",
                    "date_range": "2024-09-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-26 00:00:00 +0500",
                    "checkout_time": "2024-09-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4036,
                    "date": "2024-09-27",
                    "date_range": "2024-09-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-27 00:00:00 +0500",
                    "checkout_time": "2024-09-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3881,
                    "date": "2024-09-27",
                    "date_range": "2024-09-27",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-27 00:00:00 +0500",
                    "checkout_time": "2024-09-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3895,
                    "date": "2024-09-28",
                    "date_range": "2024-09-28",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-28 00:00:00 +0500",
                    "checkout_time": "2024-09-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4050,
                    "date": "2024-09-28",
                    "date_range": "2024-09-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-28 00:00:00 +0500",
                    "checkout_time": "2024-09-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3909,
                    "date": "2024-09-29",
                    "date_range": "2024-09-29",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-29 00:00:00 +0500",
                    "checkout_time": "2024-09-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3868,
                    "date": "2024-10-03",
                    "date_range": "2024-10-03",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-03 00:00:00 +0500",
                    "checkout_time": "2024-10-03 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4023,
                    "date": "2024-10-03",
                    "date_range": "2024-10-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-03 00:00:00 +0500",
                    "checkout_time": "2024-10-03 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4037,
                    "date": "2024-10-04",
                    "date_range": "2024-10-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-04 00:00:00 +0500",
                    "checkout_time": "2024-10-04 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3882,
                    "date": "2024-10-04",
                    "date_range": "2024-10-04",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-04 00:00:00 +0500",
                    "checkout_time": "2024-10-04 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3896,
                    "date": "2024-10-05",
                    "date_range": "2024-10-05",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-05 00:00:00 +0500",
                    "checkout_time": "2024-10-05 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4051,
                    "date": "2024-10-05",
                    "date_range": "2024-10-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-05 00:00:00 +0500",
                    "checkout_time": "2024-10-05 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3910,
                    "date": "2024-10-06",
                    "date_range": "2024-10-06",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-06 00:00:00 +0500",
                    "checkout_time": "2024-10-06 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3869,
                    "date": "2024-10-10",
                    "date_range": "2024-10-10",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-10 00:00:00 +0500",
                    "checkout_time": "2024-10-10 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4024,
                    "date": "2024-10-10",
                    "date_range": "2024-10-10",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-10 00:00:00 +0500",
                    "checkout_time": "2024-10-10 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4038,
                    "date": "2024-10-11",
                    "date_range": "2024-10-11",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-11 00:00:00 +0500",
                    "checkout_time": "2024-10-11 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3883,
                    "date": "2024-10-11",
                    "date_range": "2024-10-11",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-11 00:00:00 +0500",
                    "checkout_time": "2024-10-11 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3897,
                    "date": "2024-10-12",
                    "date_range": "2024-10-12",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-12 00:00:00 +0500",
                    "checkout_time": "2024-10-12 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4052,
                    "date": "2024-10-12",
                    "date_range": "2024-10-12",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-12 00:00:00 +0500",
                    "checkout_time": "2024-10-12 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3911,
                    "date": "2024-10-13",
                    "date_range": "2024-10-13",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-13 00:00:00 +0500",
                    "checkout_time": "2024-10-13 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3870,
                    "date": "2024-10-17",
                    "date_range": "2024-10-17",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-17 00:00:00 +0500",
                    "checkout_time": "2024-10-17 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4025,
                    "date": "2024-10-17",
                    "date_range": "2024-10-17",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-17 00:00:00 +0500",
                    "checkout_time": "2024-10-17 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4039,
                    "date": "2024-10-18",
                    "date_range": "2024-10-18",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-18 00:00:00 +0500",
                    "checkout_time": "2024-10-18 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3884,
                    "date": "2024-10-18",
                    "date_range": "2024-10-18",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-18 00:00:00 +0500",
                    "checkout_time": "2024-10-18 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3898,
                    "date": "2024-10-19",
                    "date_range": "2024-10-19",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-19 00:00:00 +0500",
                    "checkout_time": "2024-10-19 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4053,
                    "date": "2024-10-19",
                    "date_range": "2024-10-19",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-19 00:00:00 +0500",
                    "checkout_time": "2024-10-19 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3912,
                    "date": "2024-10-20",
                    "date_range": "2024-10-20",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-20 00:00:00 +0500",
                    "checkout_time": "2024-10-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3871,
                    "date": "2024-10-24",
                    "date_range": "2024-10-24",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-24 00:00:00 +0500",
                    "checkout_time": "2024-10-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4026,
                    "date": "2024-10-24",
                    "date_range": "2024-10-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-24 00:00:00 +0500",
                    "checkout_time": "2024-10-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4040,
                    "date": "2024-10-25",
                    "date_range": "2024-10-25",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-25 00:00:00 +0500",
                    "checkout_time": "2024-10-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3885,
                    "date": "2024-10-25",
                    "date_range": "2024-10-25",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-25 00:00:00 +0500",
                    "checkout_time": "2024-10-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3899,
                    "date": "2024-10-26",
                    "date_range": "2024-10-26",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-26 00:00:00 +0500",
                    "checkout_time": "2024-10-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4054,
                    "date": "2024-10-26",
                    "date_range": "2024-10-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-26 00:00:00 +0500",
                    "checkout_time": "2024-10-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3913,
                    "date": "2024-10-27",
                    "date_range": "2024-10-27",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-27 00:00:00 +0500",
                    "checkout_time": "2024-10-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3872,
                    "date": "2024-10-31",
                    "date_range": "2024-10-31",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-31 00:00:00 +0500",
                    "checkout_time": "2024-10-31 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4027,
                    "date": "2024-10-31",
                    "date_range": "2024-10-31",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-31 00:00:00 +0500",
                    "checkout_time": "2024-10-31 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4041,
                    "date": "2024-11-01",
                    "date_range": "2024-11-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-01 00:00:00 +0500",
                    "checkout_time": "2024-11-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3886,
                    "date": "2024-11-01",
                    "date_range": "2024-11-01",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-01 00:00:00 +0500",
                    "checkout_time": "2024-11-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3900,
                    "date": "2024-11-02",
                    "date_range": "2024-11-02",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-02 00:00:00 +0500",
                    "checkout_time": "2024-11-02 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4055,
                    "date": "2024-11-02",
                    "date_range": "2024-11-02",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-02 00:00:00 +0500",
                    "checkout_time": "2024-11-02 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3914,
                    "date": "2024-11-03",
                    "date_range": "2024-11-03",
                    "sch_doctor_ids": [
                        "83"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-03 00:00:00 +0500",
                    "checkout_time": "2024-11-03 07:00:00 +0500",
                    "appointments": []
                }
            ],
            "address_76": [
                {
                    "id": 8429,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4063,
                    "date": "2024-09-22",
                    "date_range": "2024-09-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-22 00:00:00 +0500",
                    "checkout_time": "2024-09-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4077,
                    "date": "2024-09-23",
                    "date_range": "2024-09-23",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-23 00:00:00 +0500",
                    "checkout_time": "2024-09-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4091,
                    "date": "2024-09-24",
                    "date_range": "2024-09-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-24 00:00:00 +0500",
                    "checkout_time": "2024-09-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4064,
                    "date": "2024-09-29",
                    "date_range": "2024-09-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-29 00:00:00 +0500",
                    "checkout_time": "2024-09-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4078,
                    "date": "2024-09-30",
                    "date_range": "2024-09-30",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-30 00:00:00 +0500",
                    "checkout_time": "2024-09-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4092,
                    "date": "2024-10-01",
                    "date_range": "2024-10-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-01 00:00:00 +0500",
                    "checkout_time": "2024-10-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4065,
                    "date": "2024-10-06",
                    "date_range": "2024-10-06",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-06 00:00:00 +0500",
                    "checkout_time": "2024-10-06 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4079,
                    "date": "2024-10-07",
                    "date_range": "2024-10-07",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-07 00:00:00 +0500",
                    "checkout_time": "2024-10-07 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4093,
                    "date": "2024-10-08",
                    "date_range": "2024-10-08",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-08 00:00:00 +0500",
                    "checkout_time": "2024-10-08 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4066,
                    "date": "2024-10-13",
                    "date_range": "2024-10-13",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-13 00:00:00 +0500",
                    "checkout_time": "2024-10-13 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4080,
                    "date": "2024-10-14",
                    "date_range": "2024-10-14",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-14 00:00:00 +0500",
                    "checkout_time": "2024-10-14 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4094,
                    "date": "2024-10-15",
                    "date_range": "2024-10-15",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-15 00:00:00 +0500",
                    "checkout_time": "2024-10-15 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4067,
                    "date": "2024-10-20",
                    "date_range": "2024-10-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-20 00:00:00 +0500",
                    "checkout_time": "2024-10-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4081,
                    "date": "2024-10-21",
                    "date_range": "2024-10-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-21 00:00:00 +0500",
                    "checkout_time": "2024-10-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4095,
                    "date": "2024-10-22",
                    "date_range": "2024-10-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-22 00:00:00 +0500",
                    "checkout_time": "2024-10-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4068,
                    "date": "2024-10-27",
                    "date_range": "2024-10-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-27 00:00:00 +0500",
                    "checkout_time": "2024-10-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4082,
                    "date": "2024-10-28",
                    "date_range": "2024-10-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-28 00:00:00 +0500",
                    "checkout_time": "2024-10-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4096,
                    "date": "2024-10-29",
                    "date_range": "2024-10-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-29 00:00:00 +0500",
                    "checkout_time": "2024-10-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4069,
                    "date": "2024-11-03",
                    "date_range": "2024-11-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-03 00:00:00 +0500",
                    "checkout_time": "2024-11-03 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4083,
                    "date": "2024-11-04",
                    "date_range": "2024-11-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-04 23:00:00 +0500",
                    "checkout_time": "2024-11-04 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4097,
                    "date": "2024-11-05",
                    "date_range": "2024-11-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-05 23:00:00 +0500",
                    "checkout_time": "2024-11-05 07:00:00 +0500",
                    "appointments": []
                }
            ]
        },
        "doctor_84": {
            "address_69": [
                {
                    "id": 4035,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4049,
                    "date": "2024-09-21",
                    "date_range": "2024-09-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-21 00:00:00 +0500",
                    "checkout_time": "2024-09-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3964,
                    "date": "2024-09-22",
                    "date_range": "2024-09-22",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-22 00:00:00 +0500",
                    "checkout_time": "2024-09-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3978,
                    "date": "2024-09-23",
                    "date_range": "2024-09-23",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-23 00:00:00 +0500",
                    "checkout_time": "2024-09-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3993,
                    "date": "2024-09-24",
                    "date_range": "2024-09-24",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-24 00:00:00 +0500",
                    "checkout_time": "2024-09-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4007,
                    "date": "2024-09-25",
                    "date_range": "2024-09-25",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-25 00:00:00 +0500",
                    "checkout_time": "2024-09-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4022,
                    "date": "2024-09-26",
                    "date_range": "2024-09-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-26 00:00:00 +0500",
                    "checkout_time": "2024-09-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4036,
                    "date": "2024-09-27",
                    "date_range": "2024-09-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-27 00:00:00 +0500",
                    "checkout_time": "2024-09-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4050,
                    "date": "2024-09-28",
                    "date_range": "2024-09-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-28 00:00:00 +0500",
                    "checkout_time": "2024-09-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3965,
                    "date": "2024-09-29",
                    "date_range": "2024-09-29",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-29 00:00:00 +0500",
                    "checkout_time": "2024-09-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3979,
                    "date": "2024-09-30",
                    "date_range": "2024-09-30",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-30 00:00:00 +0500",
                    "checkout_time": "2024-09-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3994,
                    "date": "2024-10-01",
                    "date_range": "2024-10-01",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-01 00:00:00 +0500",
                    "checkout_time": "2024-10-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4008,
                    "date": "2024-10-02",
                    "date_range": "2024-10-02",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-02 00:00:00 +0500",
                    "checkout_time": "2024-10-02 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4023,
                    "date": "2024-10-03",
                    "date_range": "2024-10-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-03 00:00:00 +0500",
                    "checkout_time": "2024-10-03 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4037,
                    "date": "2024-10-04",
                    "date_range": "2024-10-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-04 00:00:00 +0500",
                    "checkout_time": "2024-10-04 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4051,
                    "date": "2024-10-05",
                    "date_range": "2024-10-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-05 00:00:00 +0500",
                    "checkout_time": "2024-10-05 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3966,
                    "date": "2024-10-06",
                    "date_range": "2024-10-06",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-06 00:00:00 +0500",
                    "checkout_time": "2024-10-06 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3980,
                    "date": "2024-10-07",
                    "date_range": "2024-10-07",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-07 00:00:00 +0500",
                    "checkout_time": "2024-10-07 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3995,
                    "date": "2024-10-08",
                    "date_range": "2024-10-08",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-08 00:00:00 +0500",
                    "checkout_time": "2024-10-08 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4009,
                    "date": "2024-10-09",
                    "date_range": "2024-10-09",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-09 00:00:00 +0500",
                    "checkout_time": "2024-10-09 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4024,
                    "date": "2024-10-10",
                    "date_range": "2024-10-10",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-10 00:00:00 +0500",
                    "checkout_time": "2024-10-10 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4038,
                    "date": "2024-10-11",
                    "date_range": "2024-10-11",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-11 00:00:00 +0500",
                    "checkout_time": "2024-10-11 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4052,
                    "date": "2024-10-12",
                    "date_range": "2024-10-12",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-12 00:00:00 +0500",
                    "checkout_time": "2024-10-12 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3967,
                    "date": "2024-10-13",
                    "date_range": "2024-10-13",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-13 00:00:00 +0500",
                    "checkout_time": "2024-10-13 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3981,
                    "date": "2024-10-14",
                    "date_range": "2024-10-14",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-14 00:00:00 +0500",
                    "checkout_time": "2024-10-14 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3996,
                    "date": "2024-10-15",
                    "date_range": "2024-10-15",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-15 00:00:00 +0500",
                    "checkout_time": "2024-10-15 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4010,
                    "date": "2024-10-16",
                    "date_range": "2024-10-16",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-16 00:00:00 +0500",
                    "checkout_time": "2024-10-16 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4025,
                    "date": "2024-10-17",
                    "date_range": "2024-10-17",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-17 00:00:00 +0500",
                    "checkout_time": "2024-10-17 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4039,
                    "date": "2024-10-18",
                    "date_range": "2024-10-18",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-18 00:00:00 +0500",
                    "checkout_time": "2024-10-18 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4053,
                    "date": "2024-10-19",
                    "date_range": "2024-10-19",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-19 00:00:00 +0500",
                    "checkout_time": "2024-10-19 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3968,
                    "date": "2024-10-20",
                    "date_range": "2024-10-20",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-20 00:00:00 +0500",
                    "checkout_time": "2024-10-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3982,
                    "date": "2024-10-21",
                    "date_range": "2024-10-21",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-21 00:00:00 +0500",
                    "checkout_time": "2024-10-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3997,
                    "date": "2024-10-22",
                    "date_range": "2024-10-22",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-22 00:00:00 +0500",
                    "checkout_time": "2024-10-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4011,
                    "date": "2024-10-23",
                    "date_range": "2024-10-23",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-23 00:00:00 +0500",
                    "checkout_time": "2024-10-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4026,
                    "date": "2024-10-24",
                    "date_range": "2024-10-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-24 00:00:00 +0500",
                    "checkout_time": "2024-10-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4040,
                    "date": "2024-10-25",
                    "date_range": "2024-10-25",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-25 00:00:00 +0500",
                    "checkout_time": "2024-10-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4054,
                    "date": "2024-10-26",
                    "date_range": "2024-10-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-26 00:00:00 +0500",
                    "checkout_time": "2024-10-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3969,
                    "date": "2024-10-27",
                    "date_range": "2024-10-27",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-27 00:00:00 +0500",
                    "checkout_time": "2024-10-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3983,
                    "date": "2024-10-28",
                    "date_range": "2024-10-28",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-28 00:00:00 +0500",
                    "checkout_time": "2024-10-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3998,
                    "date": "2024-10-29",
                    "date_range": "2024-10-29",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-29 00:00:00 +0500",
                    "checkout_time": "2024-10-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4012,
                    "date": "2024-10-30",
                    "date_range": "2024-10-30",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-30 00:00:00 +0500",
                    "checkout_time": "2024-10-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4027,
                    "date": "2024-10-31",
                    "date_range": "2024-10-31",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-31 00:00:00 +0500",
                    "checkout_time": "2024-10-31 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4041,
                    "date": "2024-11-01",
                    "date_range": "2024-11-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-01 00:00:00 +0500",
                    "checkout_time": "2024-11-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4055,
                    "date": "2024-11-02",
                    "date_range": "2024-11-02",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-02 00:00:00 +0500",
                    "checkout_time": "2024-11-02 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3970,
                    "date": "2024-11-03",
                    "date_range": "2024-11-03",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-03 00:00:00 +0500",
                    "checkout_time": "2024-11-03 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3984,
                    "date": "2024-11-04",
                    "date_range": "2024-11-04",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-04 23:00:00 +0500",
                    "checkout_time": "2024-11-04 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3999,
                    "date": "2024-11-05",
                    "date_range": "2024-11-05",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-05 23:00:00 +0500",
                    "checkout_time": "2024-11-05 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4013,
                    "date": "2024-11-06",
                    "date_range": "2024-11-06",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-06 23:00:00 +0500",
                    "checkout_time": "2024-11-06 07:00:00 +0500",
                    "appointments": []
                }
            ],
            "address_76": [
                {
                    "id": 3936,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 8429,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3950,
                    "date": "2024-09-21",
                    "date_range": "2024-09-21",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-21 00:00:00 +0500",
                    "checkout_time": "2024-09-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4063,
                    "date": "2024-09-22",
                    "date_range": "2024-09-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-22 00:00:00 +0500",
                    "checkout_time": "2024-09-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4077,
                    "date": "2024-09-23",
                    "date_range": "2024-09-23",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-23 00:00:00 +0500",
                    "checkout_time": "2024-09-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4091,
                    "date": "2024-09-24",
                    "date_range": "2024-09-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-24 00:00:00 +0500",
                    "checkout_time": "2024-09-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3923,
                    "date": "2024-09-26",
                    "date_range": "2024-09-26",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-26 00:00:00 +0500",
                    "checkout_time": "2024-09-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3937,
                    "date": "2024-09-27",
                    "date_range": "2024-09-27",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-27 00:00:00 +0500",
                    "checkout_time": "2024-09-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3951,
                    "date": "2024-09-28",
                    "date_range": "2024-09-28",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-28 00:00:00 +0500",
                    "checkout_time": "2024-09-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4064,
                    "date": "2024-09-29",
                    "date_range": "2024-09-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-29 00:00:00 +0500",
                    "checkout_time": "2024-09-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4078,
                    "date": "2024-09-30",
                    "date_range": "2024-09-30",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-30 00:00:00 +0500",
                    "checkout_time": "2024-09-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4092,
                    "date": "2024-10-01",
                    "date_range": "2024-10-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-01 00:00:00 +0500",
                    "checkout_time": "2024-10-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3924,
                    "date": "2024-10-03",
                    "date_range": "2024-10-03",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-03 00:00:00 +0500",
                    "checkout_time": "2024-10-03 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3938,
                    "date": "2024-10-04",
                    "date_range": "2024-10-04",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-04 00:00:00 +0500",
                    "checkout_time": "2024-10-04 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3952,
                    "date": "2024-10-05",
                    "date_range": "2024-10-05",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-05 00:00:00 +0500",
                    "checkout_time": "2024-10-05 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4065,
                    "date": "2024-10-06",
                    "date_range": "2024-10-06",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-06 00:00:00 +0500",
                    "checkout_time": "2024-10-06 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4079,
                    "date": "2024-10-07",
                    "date_range": "2024-10-07",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-07 00:00:00 +0500",
                    "checkout_time": "2024-10-07 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4093,
                    "date": "2024-10-08",
                    "date_range": "2024-10-08",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-08 00:00:00 +0500",
                    "checkout_time": "2024-10-08 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3925,
                    "date": "2024-10-10",
                    "date_range": "2024-10-10",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-10 00:00:00 +0500",
                    "checkout_time": "2024-10-10 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3939,
                    "date": "2024-10-11",
                    "date_range": "2024-10-11",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-11 00:00:00 +0500",
                    "checkout_time": "2024-10-11 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3953,
                    "date": "2024-10-12",
                    "date_range": "2024-10-12",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-12 00:00:00 +0500",
                    "checkout_time": "2024-10-12 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4066,
                    "date": "2024-10-13",
                    "date_range": "2024-10-13",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-13 00:00:00 +0500",
                    "checkout_time": "2024-10-13 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4080,
                    "date": "2024-10-14",
                    "date_range": "2024-10-14",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-14 00:00:00 +0500",
                    "checkout_time": "2024-10-14 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4094,
                    "date": "2024-10-15",
                    "date_range": "2024-10-15",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-15 00:00:00 +0500",
                    "checkout_time": "2024-10-15 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3926,
                    "date": "2024-10-17",
                    "date_range": "2024-10-17",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-17 00:00:00 +0500",
                    "checkout_time": "2024-10-17 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3940,
                    "date": "2024-10-18",
                    "date_range": "2024-10-18",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-18 00:00:00 +0500",
                    "checkout_time": "2024-10-18 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3954,
                    "date": "2024-10-19",
                    "date_range": "2024-10-19",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-19 00:00:00 +0500",
                    "checkout_time": "2024-10-19 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4067,
                    "date": "2024-10-20",
                    "date_range": "2024-10-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-20 00:00:00 +0500",
                    "checkout_time": "2024-10-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4081,
                    "date": "2024-10-21",
                    "date_range": "2024-10-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-21 00:00:00 +0500",
                    "checkout_time": "2024-10-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4095,
                    "date": "2024-10-22",
                    "date_range": "2024-10-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-22 00:00:00 +0500",
                    "checkout_time": "2024-10-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3927,
                    "date": "2024-10-24",
                    "date_range": "2024-10-24",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-24 00:00:00 +0500",
                    "checkout_time": "2024-10-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3941,
                    "date": "2024-10-25",
                    "date_range": "2024-10-25",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-25 00:00:00 +0500",
                    "checkout_time": "2024-10-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3955,
                    "date": "2024-10-26",
                    "date_range": "2024-10-26",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-26 00:00:00 +0500",
                    "checkout_time": "2024-10-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4068,
                    "date": "2024-10-27",
                    "date_range": "2024-10-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-27 00:00:00 +0500",
                    "checkout_time": "2024-10-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4082,
                    "date": "2024-10-28",
                    "date_range": "2024-10-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-28 00:00:00 +0500",
                    "checkout_time": "2024-10-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4096,
                    "date": "2024-10-29",
                    "date_range": "2024-10-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-29 00:00:00 +0500",
                    "checkout_time": "2024-10-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3928,
                    "date": "2024-10-31",
                    "date_range": "2024-10-31",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-31 00:00:00 +0500",
                    "checkout_time": "2024-10-31 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3942,
                    "date": "2024-11-01",
                    "date_range": "2024-11-01",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-01 00:00:00 +0500",
                    "checkout_time": "2024-11-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 3956,
                    "date": "2024-11-02",
                    "date_range": "2024-11-02",
                    "sch_doctor_ids": [
                        "84"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-02 00:00:00 +0500",
                    "checkout_time": "2024-11-02 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4069,
                    "date": "2024-11-03",
                    "date_range": "2024-11-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-03 00:00:00 +0500",
                    "checkout_time": "2024-11-03 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4083,
                    "date": "2024-11-04",
                    "date_range": "2024-11-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-04 23:00:00 +0500",
                    "checkout_time": "2024-11-04 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4097,
                    "date": "2024-11-05",
                    "date_range": "2024-11-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-05 23:00:00 +0500",
                    "checkout_time": "2024-11-05 07:00:00 +0500",
                    "appointments": []
                }
            ]
        },
        "doctor_85": {
            "address_69": [
                {
                    "id": 4035,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4049,
                    "date": "2024-09-21",
                    "date_range": "2024-09-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-21 00:00:00 +0500",
                    "checkout_time": "2024-09-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4022,
                    "date": "2024-09-26",
                    "date_range": "2024-09-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-26 00:00:00 +0500",
                    "checkout_time": "2024-09-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4036,
                    "date": "2024-09-27",
                    "date_range": "2024-09-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-27 00:00:00 +0500",
                    "checkout_time": "2024-09-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4050,
                    "date": "2024-09-28",
                    "date_range": "2024-09-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-09-28 00:00:00 +0500",
                    "checkout_time": "2024-09-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4023,
                    "date": "2024-10-03",
                    "date_range": "2024-10-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-03 00:00:00 +0500",
                    "checkout_time": "2024-10-03 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4037,
                    "date": "2024-10-04",
                    "date_range": "2024-10-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-04 00:00:00 +0500",
                    "checkout_time": "2024-10-04 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4051,
                    "date": "2024-10-05",
                    "date_range": "2024-10-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-05 00:00:00 +0500",
                    "checkout_time": "2024-10-05 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4024,
                    "date": "2024-10-10",
                    "date_range": "2024-10-10",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-10 00:00:00 +0500",
                    "checkout_time": "2024-10-10 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4038,
                    "date": "2024-10-11",
                    "date_range": "2024-10-11",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-11 00:00:00 +0500",
                    "checkout_time": "2024-10-11 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4052,
                    "date": "2024-10-12",
                    "date_range": "2024-10-12",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-12 00:00:00 +0500",
                    "checkout_time": "2024-10-12 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4025,
                    "date": "2024-10-17",
                    "date_range": "2024-10-17",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-17 00:00:00 +0500",
                    "checkout_time": "2024-10-17 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4039,
                    "date": "2024-10-18",
                    "date_range": "2024-10-18",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-18 00:00:00 +0500",
                    "checkout_time": "2024-10-18 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4053,
                    "date": "2024-10-19",
                    "date_range": "2024-10-19",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-19 00:00:00 +0500",
                    "checkout_time": "2024-10-19 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4026,
                    "date": "2024-10-24",
                    "date_range": "2024-10-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-24 00:00:00 +0500",
                    "checkout_time": "2024-10-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4040,
                    "date": "2024-10-25",
                    "date_range": "2024-10-25",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-25 00:00:00 +0500",
                    "checkout_time": "2024-10-25 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4054,
                    "date": "2024-10-26",
                    "date_range": "2024-10-26",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-26 00:00:00 +0500",
                    "checkout_time": "2024-10-26 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4027,
                    "date": "2024-10-31",
                    "date_range": "2024-10-31",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-10-31 00:00:00 +0500",
                    "checkout_time": "2024-10-31 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4041,
                    "date": "2024-11-01",
                    "date_range": "2024-11-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-01 00:00:00 +0500",
                    "checkout_time": "2024-11-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4055,
                    "date": "2024-11-02",
                    "date_range": "2024-11-02",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 69,
                    "checkin_time": "2024-11-02 00:00:00 +0500",
                    "checkout_time": "2024-11-02 08:00:00 +0500",
                    "appointments": []
                }
            ],
            "address_76": [
                {
                    "id": 8429,
                    "date": "2024-09-20",
                    "date_range": "2024-09-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-20 00:00:00 +0500",
                    "checkout_time": "2024-09-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4063,
                    "date": "2024-09-22",
                    "date_range": "2024-09-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-22 00:00:00 +0500",
                    "checkout_time": "2024-09-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4077,
                    "date": "2024-09-23",
                    "date_range": "2024-09-23",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-23 00:00:00 +0500",
                    "checkout_time": "2024-09-23 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4091,
                    "date": "2024-09-24",
                    "date_range": "2024-09-24",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-24 00:00:00 +0500",
                    "checkout_time": "2024-09-24 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4064,
                    "date": "2024-09-29",
                    "date_range": "2024-09-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-29 00:00:00 +0500",
                    "checkout_time": "2024-09-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4078,
                    "date": "2024-09-30",
                    "date_range": "2024-09-30",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-09-30 00:00:00 +0500",
                    "checkout_time": "2024-09-30 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4092,
                    "date": "2024-10-01",
                    "date_range": "2024-10-01",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-01 00:00:00 +0500",
                    "checkout_time": "2024-10-01 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4065,
                    "date": "2024-10-06",
                    "date_range": "2024-10-06",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-06 00:00:00 +0500",
                    "checkout_time": "2024-10-06 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4079,
                    "date": "2024-10-07",
                    "date_range": "2024-10-07",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-07 00:00:00 +0500",
                    "checkout_time": "2024-10-07 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4093,
                    "date": "2024-10-08",
                    "date_range": "2024-10-08",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-08 00:00:00 +0500",
                    "checkout_time": "2024-10-08 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4066,
                    "date": "2024-10-13",
                    "date_range": "2024-10-13",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-13 00:00:00 +0500",
                    "checkout_time": "2024-10-13 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4080,
                    "date": "2024-10-14",
                    "date_range": "2024-10-14",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-14 00:00:00 +0500",
                    "checkout_time": "2024-10-14 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4094,
                    "date": "2024-10-15",
                    "date_range": "2024-10-15",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-15 00:00:00 +0500",
                    "checkout_time": "2024-10-15 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4067,
                    "date": "2024-10-20",
                    "date_range": "2024-10-20",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-20 00:00:00 +0500",
                    "checkout_time": "2024-10-20 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4081,
                    "date": "2024-10-21",
                    "date_range": "2024-10-21",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-21 00:00:00 +0500",
                    "checkout_time": "2024-10-21 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4095,
                    "date": "2024-10-22",
                    "date_range": "2024-10-22",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-22 00:00:00 +0500",
                    "checkout_time": "2024-10-22 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4068,
                    "date": "2024-10-27",
                    "date_range": "2024-10-27",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-27 00:00:00 +0500",
                    "checkout_time": "2024-10-27 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4082,
                    "date": "2024-10-28",
                    "date_range": "2024-10-28",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-28 00:00:00 +0500",
                    "checkout_time": "2024-10-28 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4096,
                    "date": "2024-10-29",
                    "date_range": "2024-10-29",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-10-29 00:00:00 +0500",
                    "checkout_time": "2024-10-29 08:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4069,
                    "date": "2024-11-03",
                    "date_range": "2024-11-03",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-03 00:00:00 +0500",
                    "checkout_time": "2024-11-03 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4083,
                    "date": "2024-11-04",
                    "date_range": "2024-11-04",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-04 23:00:00 +0500",
                    "checkout_time": "2024-11-04 07:00:00 +0500",
                    "appointments": []
                },
                {
                    "id": 4097,
                    "date": "2024-11-05",
                    "date_range": "2024-11-05",
                    "sch_doctor_ids": [
                        "82",
                        "83",
                        "84",
                        "85",
                        "57"
                    ],
                    "address_id": 76,
                    "checkin_time": "2024-11-05 23:00:00 +0500",
                    "checkout_time": "2024-11-05 07:00:00 +0500",
                    "appointments": []
                }
            ]
        },
        "doctor_181": {},
        "doctor_182": {},
        "doctor_183": {},
        "doctor_184": {},
        "doctor_185": {},
        "doctor_186": {},
        "doctor_187": {},
        "doctor_188": {},
        "doctor_189": {},
        "doctor_190": {},
        "doctor_191": {},
        "doctor_192": {},
        "doctor_193": {},
        "doctor_194": {},
        "doctor_195": {},
        "doctor_196": {}
    },
    "widget_labels": {
        "provider": {
            "placeholder": "Select Provider",
            "provider_label": "Provider"
        },
        "form_label": "Provide Your Information"
    },
    "BaseUrl": "https://emanplasticsurgery.apptmates.com",
    "SubmissionEndpoint": "/appointments/appointment_detail",
    "DataEndpoint": "/appointments/appointment_widget_data",
    "Timezone": "Islamabad",
    "AuthenticityToken": "Jxyn/FefMvgaMKzZTpBnxJ1ymwtoOakzQZsQ9hKvVleXKZEIO04eRqza+fOprBmfryVjrErrF0qVryZEcts2uQ==",
    "DaysToShow": 7,
    "hours_to_skip_schedules": 2,
    "start_datetime": "2024-09-20 19:07:00 +0500",
    "NoResultFound": "No Results Found !",
    "BusinessDetails": {
        "primary_phone": "(573)768-8227",
        "website_link": "www.digitalstandout.com",
        "name": "Digital Standout"
    }
}
 

 export const field_types = [
	{
		"id" : 1,
		"slug" : "short_text",
		"created_at" : "2024-01-05T14:48:08.855Z",
		"updated_at" : "2024-01-05T14:48:08.855Z"
	},
	{
		"id" : 2,
		"slug" : "long_text",
		"created_at" : "2024-01-05T15:11:13.542Z",
		"updated_at" : "2024-01-05T15:11:13.542Z"
	},
	{
		"id" : 3,
		"slug" : "number",
		"created_at" : "2024-01-05T15:11:54.924Z",
		"updated_at" : "2024-01-05T15:11:54.924Z"
	},
	{
		"id" : 4,
		"slug" : "date",
		"created_at" : "2024-01-05T15:12:24.429Z",
		"updated_at" : "2024-01-05T15:12:24.429Z"
	},
	{
		"id" : 5,
		"slug" : "select",
		"created_at" : "2024-01-05T15:12:38.440Z",
		"updated_at" : "2024-01-05T15:12:38.440Z"
	},
	{
		"id" : 6,
		"slug" : "multi_select",
		"created_at" : "2024-01-05T15:12:47.100Z",
		"updated_at" : "2024-01-05T15:12:47.100Z"
	},
	{
		"id" : 7,
		"slug" : "checkbox",
		"created_at" : "2024-01-05T15:12:57.001Z",
		"updated_at" : "2024-01-05T15:12:57.001Z"
	},
	{
		"id" : 8,
		"slug" : "radio",
		"created_at" : "2024-01-05T15:39:52.221Z",
		"updated_at" : "2024-01-05T15:39:52.221Z"
	}
]

export const baseUrl = 'http://127.0.0.1:3000/appointments/appointment_detail';
